function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var i = 0; i < t.length; i++) {
    var o = t[i];
    (o.enumerable = o.enumerable || !1),
      (o.configurable = !0),
      "value" in o && (o.writable = !0),
      Object.defineProperty(e, o.key, o);
  }
}
function _createClass(e, t, i) {
  return (
    t && _defineProperties(e.prototype, t), i && _defineProperties(e, i), e
  );
}
function _typeof(e) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function e(t) {
          return typeof t;
        }
      : function e(t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t;
        })(e);
}
!(function (e) {
  var t,
    i,
    o,
    n,
    a,
    s,
    e = (jQuery = e),
    r = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function t(i) {
      i.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate(e(this).val());
        }
      );
    },
    unload: function e(t) {
      t.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function t(i) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            e.post(
              theme.routes.cart_url + "/update.js",
              { note: i },
              function (e) {},
              "json"
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval
        ));
    },
  }),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (e, t, i, o) {
      if (void 0 === theme.scriptsLoaded[e]) {
        theme.scriptsLoaded[e] = [];
        var n = document.createElement("script");
        (n.src = e),
          (o || i) && (n.async = !1),
          i && i(),
          "function" == typeof t &&
            (theme.scriptsLoaded[e].push(t),
            n.readyState
              ? (n.onreadystatechange = function () {
                  if ("loaded" == n.readyState || "complete" == n.readyState) {
                    n.onreadystatechange = null;
                    for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                      theme.scriptsLoaded[this][e]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(e))
              : (n.onload = function () {
                  for (var e = 0; e < theme.scriptsLoaded[this].length; e++)
                    theme.scriptsLoaded[this][e]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(e)));
        var a = document.getElementsByTagName("script")[0];
        return a.parentNode.insertBefore(n, a), !0;
      }
      if (
        "object" !== _typeof(theme.scriptsLoaded[e]) ||
        "function" != typeof t
      )
        return "function" == typeof t && t(), !1;
      theme.scriptsLoaded[e].push(t);
    }),
    (theme.loadStyleOnce = function (e) {
      var t = e.replace(/^https?:/, "");
      if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
        var i = document.createElement("link");
        (i.href = t), (i.rel = "stylesheet"), (i.type = "text/css");
        var o = document.getElementsByTagName("link")[0];
        o.parentNode.insertBefore(i, o);
      }
    }),
    (theme.Disclosure = (function () {
      var t = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        i = { listVisible: "disclosure-list--visible" };
      function o(e) {
        (this.$container = e),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (o.prototype = e.extend({}, o.prototype, {
          _cacheSelectors: function e() {
            this.cache = {
              $disclosureList: this.$container.find(t.disclosureList),
              $disclosureToggle: this.$container.find(t.disclosureToggle),
              $disclosureInput: this.$container.find(t.disclosureInput),
              $disclosureOptions: this.$container.find(t.disclosureOptions),
            };
          },
          _connectToggle: function t() {
            this.cache.$disclosureToggle.on(
              "click",
              function (t) {
                var o = "true" === e(t.currentTarget).attr("aria-expanded");
                e(t.currentTarget).attr("aria-expanded", !o),
                  this.cache.$disclosureList.toggleClass(i.listVisible);
              }.bind(this)
            );
          },
          _connectOptions: function t() {
            this.cache.$disclosureOptions.on(
              "click",
              function (t) {
                t.preventDefault(),
                  this._submitForm(e(t.currentTarget).data("value"));
              }.bind(this)
            );
          },
          _onFocusOut: function t() {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (e) {
                0 === this.$container.has(e.relatedTarget).length &&
                  this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (t) {
                  var o = e(t.currentTarget).has(t.relatedTarget).length > 0;
                  this.cache.$disclosureList.hasClass(i.listVisible) &&
                    !o &&
                    this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (e) {
                  27 === e.which &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (e) {
                var t = this.$container.has(e.target).length > 0;
                this.cache.$disclosureList.hasClass(i.listVisible) &&
                  !t &&
                  this._hideList();
              }.bind(this)),
              e("body").on("click", this.bodyOnClick);
          },
          _submitForm: function e(t) {
            this.cache.$disclosureInput.val(t),
              this.$container.parents("form").submit();
          },
          _hideList: function e() {
            this.cache.$disclosureList.removeClass(i.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function t() {
            e("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        o
      );
    })()),
    (e.fn.clickyBoxes = function (t) {
      if ("destroy" != t)
        return e(this)
          .filter("select:not(.clickybox-replaced)")
          .addClass("clickybox-replaced")
          .each(function () {
            var t,
              i = i || e(this).attr("id"),
              o = e('<ul class="clickyboxes"/>')
                .attr("id", "clickyboxes-" + i)
                .data("select", e(this))
                .insertAfter(this);
            (t = e(this).is("[id]")
              ? e('label[for="' + e(this).attr("id") + '"]')
              : e(this).siblings("label")).length > 0 &&
              o.addClass(
                "options-" +
                  removeDiacritics(t.text())
                    .toLowerCase()
                    .replace(/'/g, "")
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-+/g, "-")
                    .replace(/-*$/, "")
              ),
              e(this)
                .find("option")
                .each(function () {
                  e("<li/>")
                    .appendTo(o)
                    .append(
                      e('<a href="#"/>')
                        .attr("data-value", e(this).val())
                        .html(e(this).html())
                        .addClass(
                          "opt--" +
                            removeDiacritics(e(this).text())
                              .toLowerCase()
                              .replace(/'/g, "")
                              .replace(/[^a-z0-9]+/g, "-")
                              .replace(/-+/g, "-")
                              .replace(/-*$/, "")
                        )
                    );
                }),
              e(this)
                .hide()
                .addClass("replaced")
                .on("change.clickyboxes keyup.clickyboxes", function () {
                  var t = e(this).val();
                  o.find("a")
                    .removeClass("active")
                    .filter(function () {
                      return e(this).attr("data-value") == t;
                    })
                    .addClass("active");
                })
                .trigger("keyup"),
              o.on("click.clickyboxes", "a", function () {
                if (!e(this).hasClass("active")) {
                  var t = e(this).closest(".clickyboxes");
                  t.data("select").val(e(this).data("value")).trigger("change"),
                    t.trigger("change");
                }
                return !1;
              });
          });
      e(this).off(".clickyboxes"),
        e(this).next(".clickyboxes").off(".clickyboxes");
    }),
    (i = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
    (n = 200),
    window.addEventListener(
      "scroll",
      ((o = function () {
        window.dispatchEvent(i);
      }),
      (a = -1),
      (s = !1),
      function () {
        clearTimeout(a),
          (a = setTimeout(o, n)),
          s ||
            (o.call(),
            (s = !0),
            setTimeout(function () {
              s = !1;
            }, n));
      })
    ),
    (theme.Sections = new (function () {
      var t = this;
      (t._instances = []),
        (t._deferredSectionTargets = []),
        (t._sections = []),
        (t._deferredLoadViewportExcess = 300),
        (t._deferredWatcherRunning = !1),
        (t.init = function () {
          e(document)
            .on("shopify:section:load", function (e) {
              var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
              i && t.sectionLoad(i);
            })
            .on("shopify:section:unload", function (e) {
              var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
              i && t.sectionUnload(i);
            }),
            e(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              t._processDeferredSections
            ),
            (t._deferredWatcherRunning = !0);
        }),
        (t.register = function (i, o, n) {
          t._sections.push({
            type: i,
            section: o,
            afterSectionLoadCallback: n ? n.afterLoad : null,
            afterSectionUnloadCallback: n ? n.afterUnload : null,
          }),
            e('[data-section-type="' + i + '"]').each(function () {
              Shopify.designMode ||
              (n && !1 === n.deferredLoad) ||
              !t._deferredWatcherRunning
                ? t.sectionLoad(this)
                : t.sectionDeferredLoad(this, n);
            });
        }),
        (t.sectionDeferredLoad = function (e, i) {
          t._deferredSectionTargets.push({
            target: e,
            deferredLoadViewportExcess:
              i && i.deferredLoadViewportExcess
                ? i.deferredLoadViewportExcess
                : t._deferredLoadViewportExcess,
          }),
            t._processDeferredSections(!0);
        }),
        (t._processDeferredSections = function (i) {
          if (t._deferredSectionTargets.length)
            for (
              var o = e(window).scrollTop(),
                n = o + e(window).height(),
                a = !0 === i ? t._deferredSectionTargets.length - 1 : 0,
                s = a;
              s < t._deferredSectionTargets.length;
              s++
            ) {
              var r = t._deferredSectionTargets[s].target,
                c = t._deferredSectionTargets[s].deferredLoadViewportExcess,
                l = e(r).offset().top - c,
                d = l > o && l < n;
              if (!d) {
                var h = l + e(r).outerHeight() + 2 * c;
                d = h > o && h < n;
              }
              (d || (l < o && h > n)) &&
                (t.sectionLoad(r), t._deferredSectionTargets.splice(s, 1), s--);
            }
          !0 !== i &&
            0 === t._deferredSectionTargets.length &&
            ((t._deferredWatcherRunning = !1),
            e(window).off(".themeSectionDeferredLoader"));
        }),
        (t.sectionLoad = function (i) {
          var i = i,
            o = t._sectionForTarget(i),
            n = !1;
          if (!1 !== (n = o.section ? o.section : o)) {
            var a = {
              target: i,
              section: n,
              $shopifySectionContainer: e(i).closest(".shopify-section"),
              thisContext: { functions: n.functions },
            };
            t._instances.push(a),
              e(i).data("components") &&
                e(i)
                  .data("components")
                  .split(",")
                  .forEach(function (t) {
                    e(document).trigger("cc:component:load", [t, i]);
                  }),
              t._callSectionWith(n, "onSectionLoad", i, a.thisContext),
              t._callSectionWith(
                n,
                "afterSectionLoadCallback",
                i,
                a.thisContext
              ),
              n.onSectionSelect &&
                a.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (e) {
                    t._callSectionWith(
                      n,
                      "onSectionSelect",
                      e.target,
                      a.thisContext
                    );
                  }
                ),
              n.onSectionDeselect &&
                a.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (e) {
                    t._callSectionWith(
                      n,
                      "onSectionDeselect",
                      e.target,
                      a.thisContext
                    );
                  }
                ),
              n.onBlockSelect &&
                e(i).on("shopify:block:select", function (e) {
                  t._callSectionWith(
                    n,
                    "onBlockSelect",
                    e.target,
                    a.thisContext
                  );
                }),
              n.onBlockDeselect &&
                e(i).on("shopify:block:deselect", function (e) {
                  t._callSectionWith(
                    n,
                    "onBlockDeselect",
                    e.target,
                    a.thisContext
                  );
                });
          }
        }),
        (t.sectionUnload = function (i) {
          for (
            var o = t._sectionForTarget(i), n = -1, a = 0;
            a < t._instances.length;
            a++
          )
            t._instances[a].target == i && (n = a);
          if (n > -1) {
            var s = t._instances[n];
            e(i).off("shopify:block:select shopify:block:deselect"),
              s.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
              ),
              t._callSectionWith(
                s.section,
                "onSectionUnload",
                i,
                s.thisContext
              ),
              t._callSectionWith(
                o,
                "afterSectionUnloadCallback",
                i,
                s.thisContext
              ),
              t._instances.splice(n),
              e(i).data("components") &&
                e(i)
                  .data("components")
                  .split(",")
                  .forEach(function (t) {
                    e(document).trigger("cc:component:unload", [t, i]);
                  });
          } else
            for (var a = 0; a < t._deferredSectionTargets.length; a++)
              if (t._deferredSectionTargets[a].target == i) {
                t._deferredSectionTargets[a].splice(a, 1);
                break;
              }
        }),
        (t._callSectionWith = function (e, t, i, o) {
          if ("function" == typeof e[t])
            try {
              o ? e[t].bind(o)(i) : e[t](i);
            } catch (n) {
              var a = i.dataset.sectionType;
              console.log(
                "Theme warning: '"
                  .concat(t, "' failed for section '")
                  .concat(a, "'")
              ),
                console.debug(i, n.stack);
            }
        }),
        (t._themeSectionTargetFromShopifySectionTarget = function (t) {
          var i = e("[data-section-type]:first", t);
          return i.length > 0 && i[0];
        }),
        (t._sectionForTarget = function (i) {
          for (
            var o = e(i).attr("data-section-type"), n = 0;
            n < t._sections.length;
            n++
          )
            if (t._sections[n].type == o) return t._sections[n];
          return !1;
        }),
        (t._sectionAlreadyRegistered = function (e) {
          for (var i = 0; i < t._sections.length; i++)
            if (t._sections[i].type == e) return !0;
          return !1;
        });
    })()),
    (theme.showQuickPopup = function (t, i) {
      var o = e('<div class="simple-popup"/>'),
        n = i.offset(),
        a = (o.outerWidth() - i.outerWidth()) / 2;
      o.html(t).css({ left: n.left, top: n.top }).hide(),
        e("body").append(o),
        o.css({
          marginTop: -o.outerHeight() - 10,
          marginLeft: n.left - a > 0 ? a : 0,
        }),
        o
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            e(this).remove();
          });
    }),
    (theme.Shopify = {
      formatMoney: function e(t, i) {
        function o(e, t) {
          return void 0 === e ? t : e;
        }
        function n(e, t, i, n) {
          if (
            ((t = o(t, 2)),
            (i = o(i, ",")),
            (n = o(n, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          var a = (e = (e / 100).toFixed(t)).split(".");
          return (
            a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
            (a[1] ? n + a[1] : "")
          );
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var a = "",
          s = /\{\{\s*(\w+)\s*\}\}/,
          r = i || this.money_format;
        switch (r.match(s)[1]) {
          case "amount":
            a = n(t, 2);
            break;
          case "amount_no_decimals":
            a = n(t, 0);
            break;
          case "amount_with_comma_separator":
            a = n(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            a = n(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            a = n(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            a = n(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            a = n(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            a = n(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            a = n(t, 2, ".", ".");
        }
        return r.replace(s, a);
      },
      formatImage: function e(t, i) {
        return t ? t.replace(/^(.*)\.([^\.]*)$/g, "$1_" + i + ".$2") : "";
      },
      Image: {
        imageSize: function e(t) {
          var i = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== i ? i[1] : null;
        },
        getSizedImageUrl: function e(t, i) {
          if (null == i) return t;
          if ("master" == i) return this.removeProtocol(t);
          var o = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != o) {
            var n = t.split(o[0]),
              a = o[0];
            return this.removeProtocol(n[0] + "_" + i + a);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    });
  var c = (function () {
    "use strict";
    function t(e, i) {
      _classCallCheck(this, t),
        (this.$container = e),
        (this.namespace = i),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    return (
      _createClass(t, [
        {
          key: "open",
          value: function t(i) {
            var o = this;
            if (this.$container.data("freeze-scroll")) {
              e("body").addClass(this.cssClasses.bodyNoScroll);
              var n = document.createElement("div");
              (n.className = "popup-scrollbar-measure"),
                document.body.appendChild(n);
              var a = n.getBoundingClientRect().width - n.clientWidth;
              document.body.removeChild(n),
                a > 0 &&
                  e("body")
                    .css("padding-right", a + "px")
                    .addClass(this.cssClasses.bodyNoScrollPadRight);
            }
            this.$container.addClass(this.cssClasses.visible),
              (this.previouslyActiveElement = document.activeElement),
              setTimeout(function () {
                o.$container.find(".cc-popup-close")[0].focus();
              }, 500),
              e(window).on("keydown" + this.namespace, function (e) {
                27 === e.keyCode && o.close();
              }),
              i && i();
          },
        },
        {
          key: "close",
          value: function t(i) {
            var o = this;
            if (
              (this.$container.removeClass(this.cssClasses.visible),
              this.previouslyActiveElement &&
                e(this.previouslyActiveElement).focus(),
              e(window).off("keydown" + this.namespace),
              this.$container.data("freeze-scroll"))
            ) {
              var n = 500,
                a = this.$container.find(".cc-popup-modal");
              a.length &&
                (n = parseFloat(getComputedStyle(a[0]).transitionDuration)) &&
                n > 0 &&
                (n *= 1e3),
                setTimeout(function () {
                  e("body")
                    .removeClass(o.cssClasses.bodyNoScroll)
                    .removeClass(o.cssClasses.bodyNoScrollPadRight)
                    .css("padding-right", "0");
                }, n);
            }
            i && i();
          },
        },
      ]),
      t
    );
  })();
  (theme.MapSection = new (function () {
    var t = this;
    (t.config = {
      zoom: 14,
      styles: {
        default: [],
        silver: [
          { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#dadada" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#c9c9c9" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
        ],
        retro: [
          { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f1e6" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#c9b2a6" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{ color: "#dcd2be" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#ae9e90" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#93817c" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#a5b076" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#447530" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#f5f1e6" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#fdfcf8" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#f8c967" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#e9bc62" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#e98d58" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [{ color: "#db8555" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#806b63" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8f7d77" }],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ebe3cd" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#b9d3c2" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#92998d" }],
          },
        ],
        dark: [
          { elementType: "geometry", stylers: [{ color: "#212121" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#181818" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1b1b1b" }],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: "#2c2c2c" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8a8a8a" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#373737" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#3c3c3c" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#4e4e4e" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3d3d3d" }],
          },
        ],
        night: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
        aubergine: [
          { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1a3646" }],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [{ color: "#4b6878" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#64779e" }],
          },
          {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [{ color: "#4b6878" }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [{ color: "#334e87" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#283d6a" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6f9ba5" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3C7680" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#304a7d" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#98a5be" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#2c6675" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#255763" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#b0d5ce" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#98a5be" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [{ color: "#283d6a" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#3a4762" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#0e1626" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#4e6d70" }],
          },
        ],
      },
    }),
      (t.apiStatus = null),
      (this.geolocate = function (t) {
        var i = e.Deferred(),
          o = new google.maps.Geocoder(),
          n = t.data("address-setting");
        return (
          o.geocode({ address: n }, function (e, t) {
            t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
          }),
          i
        );
      }),
      (this.createMap = function (i) {
        var o = e(".map-section__map-container", i);
        return t
          .geolocate(o)
          .then(
            function (n) {
              var a = {
                zoom: t.config.zoom,
                styles: t.config.styles[e(i).data("map-style")],
                center: n[0].geometry.location,
                scrollwheel: !1,
                disableDoubleClickZoom: !0,
                disableDefaultUI: !0,
                zoomControl: !0,
              };
              (t.map = new google.maps.Map(o[0], a)),
                (t.center = t.map.getCenter()),
                new google.maps.Marker({
                  map: t.map,
                  position: t.center,
                  clickable: !1,
                }),
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(t.map, "resize"),
                    t.map.setCenter(t.center);
                });
            }.bind(this)
          )
          .fail(function () {
            var e;
            switch (status) {
              case "ZERO_RESULTS":
                e = theme.strings.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                e = theme.strings.addressQueryLimit;
                break;
              default:
                e = theme.strings.addressError;
            }
            if (Shopify.designMode) {
              var t = o.parents(".map-section");
              t.addClass("page-width map-section--load-error"),
                t
                  .find(".map-section__wrapper")
                  .html('<div class="errors text-center">' + e + "</div>");
            }
          });
      }),
      (this.onSectionLoad = function (i) {
        var o = e(i);
        window.gm_authFailure = function () {
          Shopify.designMode &&
            (o.addClass("page-width map-section--load-error"),
            o
              .find(".map-section__wrapper")
              .html(
                '<div class="errors text-center">' +
                  theme.strings.authError +
                  "</div>"
              ));
        };
        var n = o.data("api-key");
        "string" == typeof n &&
          "" !== n &&
          theme.loadScriptOnce(
            "https://maps.googleapis.com/maps/api/js?key=" + n,
            function () {
              t.createMap(o);
            }
          );
      }),
      (this.onSectionUnload = function (e) {
        void 0 !== window.google &&
          void 0 !== google.maps &&
          google.maps.event.clearListeners(this.map, "resize");
      });
  })()),
    r.sections.push({ name: "map", section: theme.MapSection }),
    (theme.VideoManager = new (function () {
      var t = this;
      (t._permitPlayback = function (t) {
        return !(
          e(t).hasClass("video-container--background") &&
          768 > e(window).outerWidth()
        );
      }),
        (t.youtubeVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="youtube"]:not(.video--init)',
        }),
        (t.youtubeApiReady = function () {
          (t.youtubeVars.apiReady = !0), t._loadYoutubeVideos();
        }),
        (t._loadYoutubeVideos = function (i) {
          e(t.youtubeVars.toProcessSelector, i).length &&
            (t.youtubeVars.apiReady
              ? e(t.youtubeVars.toProcessSelector, i).each(function () {
                  if (t._permitPlayback(e(this))) {
                    e(this).addClass("video--init"),
                      t.youtubeVars.incrementor++;
                    var i = "theme-yt-video-" + t.youtubeVars.incrementor;
                    e(this).data("video-container-id", i);
                    var o = e('<div class="video-container__video-element">')
                        .attr("id", i)
                        .appendTo(e(".video-container__video", this)),
                      n = e(this).data("video-autoplay"),
                      a = e(this).data("video-loop"),
                      s = new YT.Player(i, {
                        height: "360",
                        width: "640",
                        videoId: e(this).data("video-id"),
                        playerVars: {
                          iv_load_policy: 3,
                          modestbranding: 1,
                          autoplay: n ? 1 : 0,
                          loop: a ? 1 : 0,
                          playlist: e(this).data("video-id"),
                          rel: 0,
                          showinfo: 0,
                        },
                        events: {
                          onReady: t._onYoutubePlayerReady.bind({
                            autoplay: n,
                            loop: a,
                            $container: e(this),
                          }),
                          onStateChange: t._onYoutubePlayerStateChange.bind({
                            autoplay: n,
                            loop: a,
                            $container: e(this),
                          }),
                        },
                      });
                    t.youtubeVars.videoData[i] = {
                      id: i,
                      container: this,
                      videoElement: o,
                      player: s,
                    };
                  }
                })
              : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
        }),
        (t._onYoutubePlayerReady = function (e) {
          e.target.setPlaybackQuality("hd1080"),
            this.autoplay && (e.target.mute(), e.target.playVideo()),
            t._initBackgroundVideo(this.$container);
        }),
        (t._onYoutubePlayerStateChange = function (e) {
          if (
            e.data == YT.PlayerState.PLAYING &&
            (this.$container.addClass("video--play-started"),
            this.autoplay && e.target.mute(),
            this.loop)
          ) {
            var t = e.target.getDuration() - 1;
            t > 2 &&
              (function i() {
                e.target.getCurrentTime() > t && e.target.seekTo(0),
                  setTimeout(i, 250);
              })();
          }
        }),
        (t._unloadYoutubeVideos = function (i) {
          for (var o in t.youtubeVars.videoData) {
            var n = t.youtubeVars.videoData[o];
            if (e(i).find(n.container).length) {
              n.player.destroy(), delete t.youtubeVars.videoData[o];
              return;
            }
          }
        }),
        (t.vimeoVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
        }),
        (t.vimeoApiReady = function () {
          (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
        }),
        (t._loadVimeoVideos = function (i) {
          e(t.vimeoVars.toProcessSelector, i).length &&
            (t.vimeoVars.apiReady
              ? e(t.vimeoVars.toProcessSelector, i).each(function () {
                  if (t._permitPlayback(e(this))) {
                    e(this).addClass("video--init"), t.vimeoVars.incrementor++;
                    var i = e(this),
                      o = "theme-vi-video-" + t.vimeoVars.incrementor;
                    e(this).data("video-container-id", o);
                    var n = e('<div class="video-container__video-element">')
                        .attr("id", o)
                        .appendTo(e(".video-container__video", this)),
                      a = !!e(this).data("video-autoplay"),
                      s = new Vimeo.Player(o, {
                        url: e(this).data("video-url"),
                        width: 640,
                        loop: e(this).data("video-autoplay"),
                        autoplay: a,
                        muted: i.hasClass("video-container--background"),
                      });
                    s.on(
                      "playing",
                      function () {
                        e(this).addClass("video--play-started");
                      }.bind(this)
                    ),
                      s.ready().then(function () {
                        if (
                          (a && (s.setVolume(0), s.play()),
                          s.element && s.element.width && s.element.height)
                        ) {
                          var e =
                            parseInt(s.element.height) /
                            parseInt(s.element.width);
                          i.find(".video-container__video").css(
                            "padding-bottom",
                            100 * e + "%"
                          );
                        }
                        t._initBackgroundVideo(i);
                      }),
                      (t.vimeoVars.videoData[o] = {
                        id: o,
                        container: this,
                        videoElement: n,
                        player: s,
                        autoPlay: a,
                      });
                  }
                })
              : window.define
              ? theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (t.vimeoVars.apiReady = !0),
                      t._loadVimeoVideos(),
                      (window.define = window.tempDefine);
                  },
                  function () {
                    (window.tempDefine = window.define), (window.define = null);
                  }
                )
              : theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                  }
                ));
        }),
        (t._unloadVimeoVideos = function (i) {
          for (var o in t.vimeoVars.videoData) {
            var n = t.vimeoVars.videoData[o];
            if (e(i).find(n.container).length) {
              n.player.unload(), delete t.vimeoVars.videoData[o];
              return;
            }
          }
        }),
        (t._loadThirdPartyApis = function (i) {
          t._permitPlayback(e(".video-container", i)) &&
            (t._loadYoutubeVideos(i), t._loadVimeoVideos(i));
        }),
        (t.mp4Vars = {
          incrementor: 0,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="mp4"]:not(.video--init)',
        }),
        (t._loadMp4Videos = function (i) {
          e(t.mp4Vars.toProcessSelector, i).length &&
            e(t.mp4Vars.toProcessSelector, i)
              .addClass("video--init")
              .each(function () {
                t.mp4Vars.incrementor++, e(this);
                var i = "theme-mp-video-" + t.mp4Vars.incrementor;
                e(this).data("video-container-id", i);
                var o = e('<div class="video-container__video-element">')
                    .attr("id", i)
                    .appendTo(e(".video-container__video", this)),
                  n = e("<video playsinline>");
                e(this).data("video-loop") && n.attr("loop", "loop"),
                  e(this).data("video-autoplay") &&
                    (n.attr({ autoplay: "autoplay", muted: "muted" }),
                    (n[0].muted = !0),
                    n.one("loadeddata", function () {
                      this.play();
                    })),
                  n.on(
                    "playing",
                    function () {
                      e(this).addClass("video--play-started");
                    }.bind(this)
                  ),
                  n.attr("src", e(this).data("video-url")).appendTo(o);
              });
        }),
        (t._unloadMp4Videos = function (e) {}),
        (t._initBackgroundVideo = function (t) {
          if (
            t.hasClass("video-container--background") &&
            t.find(".video-container__video iframe").length
          ) {
            var i = function t() {
              var i = this.width(),
                o = this.height(),
                n = e(".video-container__video iframe", this),
                a = n.attr("width") / n.attr("height"),
                s = e(".video-container__video", this);
              if (i / o > a) {
                var r = i / a + 150;
                s.css({
                  marginTop: (o - r) / 2 - 75,
                  marginLeft: "",
                  height: r + 150,
                  width: "",
                });
              } else {
                var c = i * a + 150 * a;
                s.css({
                  marginTop: -75,
                  marginLeft: (i - c) / 2,
                  height: o + 150,
                  width: c,
                });
              }
            };
            i.bind(t)(),
              e(window).on(
                "debouncedresize." + t.data("video-container-id"),
                i.bind(t)
              );
          }
        }),
        (this.onSectionLoad = function (i) {
          e(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var t = e(this).data("video-url");
              t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"),
                t.indexOf("vimeo.com") > -1 &&
                  (e(this).attr("data-video-type", "vimeo"),
                  e(this).attr(
                    "data-video-id",
                    t.split("?")[0].split("/").pop()
                  )),
                (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) &&
                  (e(this).attr("data-video-type", "youtube"),
                  t.indexOf("v=") > -1
                    ? e(this).attr(
                        "data-video-id",
                        t.split("v=").pop().split("&")[0]
                      )
                    : e(this).attr(
                        "data-video-id",
                        t.split("?")[0].split("/").pop()
                      ));
            }
          ),
            t._loadThirdPartyApis(i),
            t._loadMp4Videos(i),
            e(window).on("debouncedresize.video-manager-resize", function () {
              t._loadThirdPartyApis(i);
            }),
            e(".video-container__play", i).on("click", function (o) {
              o.preventDefault();
              var n = e(this).closest(".video-container");
              n.addClass("video-container--playing"),
                e(i).trigger("cc:video:play");
              var a = n.data("video-container-id");
              0 === a.indexOf("theme-yt-video")
                ? t.youtubeVars.videoData[a].player.playVideo()
                : t.vimeoVars.videoData[a].player.play();
            }),
            e(".video-container__stop", i).on("click", function (o) {
              o.preventDefault();
              var n = e(this).closest(".video-container");
              n.removeClass("video-container--playing"),
                e(i).trigger("cc:video:stop");
              var a = n.data("video-container-id");
              0 === a.indexOf("theme-yt-video")
                ? t.youtubeVars.videoData[a].player.stopVideo()
                : (t.vimeoVars.videoData[a].player.pause(),
                  t.vimeoVars.videoData[a].player.setCurrentTime(0));
            });
        }),
        (this.onSectionUnload = function (i) {
          e(".video-container__play, .video-container__stop", i).off("click"),
            e(window).off(
              "." + e(".video-container").data("video-container-id")
            ),
            e(window).off("debouncedresize.video-manager-resize"),
            t._unloadYoutubeVideos(i),
            t._unloadVimeoVideos(i),
            t._unloadMp4Videos(i),
            e(i).trigger("cc:video:stop");
        });
    })()),
    (window.onYouTubeIframeAPIReady = function () {
      theme.VideoManager.youtubeApiReady();
    }),
    r.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.NestedSectionsSection = new (function () {
      (this.onSectionLoad = function (t) {
        e("[data-nested-section-type]", t).each(function () {
          for (
            var t = e(this).attr("data-nested-section-type"), i = null, o = 0;
            o < theme.Sections._sections.length;
            o++
          )
            theme.Sections._sections[o].type == t &&
              (i = theme.Sections._sections[o].section);
          if (i) {
            var n = {
              target: this,
              section: i,
              $shopifySectionContainer: e(this).closest(".shopify-section"),
              thisContext: {},
            };
            theme.Sections._instances.push(n),
              e(this).data("themeSectionInstance", n),
              i.onSectionLoad.bind(n.thisContext)(this);
          }
        });
      }),
        (this.onSectionUnload = function (t) {
          e("[data-nested-section-type]", t).each(function () {
            e(this).data("themeSectionInstance") &&
              theme.Sections.sectionUnload.bind(
                e(this).data("themeSectionInstance").thisContext
              )(this);
          });
        }),
        (this.onBlockSelect = function (t) {
          e(window).scrollTop(e(t).offset().top - 100);
        });
    })()),
    r.sections.push({
      name: "nested-sections",
      section: theme.NestedSectionsSection,
    }),
    (theme.Popup = new (function () {
      var t = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (i) {
        var o = this;
        (this.namespace = theme.namespaceFromSection(i)),
          (this.$container = e(i)),
          (this.popup = new c(this.$container, this.namespace));
        var n = this.$container.data("dismiss-for-days"),
          a = this.$container.data("delay-seconds"),
          s = !0,
          r = this.$container.data("test-mode"),
          l = window.localStorage.getItem(t);
        l && (new Date().getTime() - l) / 864e5 < n && (s = !1),
          this.$container.find(".cc-popup-form__response").length &&
            ((s = !0),
            (a = 1),
            this.$container.find(".cc-popup-form__response--success").length &&
              this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") && (s = !1),
          (s || r) &&
            setTimeout(function () {
              o.popup.open();
            }, 1e3 * a),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            function () {
              o.popup.close(function () {
                o.functions.popupSetAsDismissed.call(o);
              });
            }
          );
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function e() {
            window.localStorage.setItem(t, new Date().getTime());
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    r.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.StoreAvailability = function (t) {
      var i = "store-availability-loading",
        o = "store-availability-initialized",
        n = "cc-location";
      (this.onSectionLoad = function (t) {
        var i = this;
        (this.namespace = theme.namespaceFromSection(t)),
          (this.$container = e(t)),
          (this.productId = this.$container.data(
            "store-availability-container"
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal;
        var o = !0;
        e(window).on(
          "cc-variant-updated".concat(this.namespace).concat(this.productId),
          function (e, t) {
            t.product.id === i.productId &&
              (i.functions.updateContent.bind(i)(
                t.variant.id,
                t.product.title,
                o,
                i.$container.data("has-only-default-variant"),
                void 0 !== t.variant.available
              ),
              (o = !1));
          }
        ),
          this.$container.data("single-variant-id") &&
            (this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              o,
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available")
            ),
            (o = !1));
      }),
        (this.onSectionUnload = function () {
          e(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId)
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function e() {
            return new Promise(function (e, t) {
              var i;
              sessionStorage[n] && (i = JSON.parse(sessionStorage[n])),
                i
                  ? e(i)
                  : navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      function (t) {
                        var i = {
                          latitude: t.coords.latitude,
                          longitude: t.coords.longitude,
                        };
                        fetch("/localization.json", {
                          method: "PUT",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(i),
                        }),
                          (sessionStorage[n] = JSON.stringify(i)),
                          e(i);
                      },
                      function () {
                        e(!1);
                      },
                      { maximumAge: 36e5, timeout: 5e3 }
                    )
                  : e(!1);
            });
          },
          getAvailableStores: function t(i, o) {
            return e.get(this.sectionUrl.replace("VARIANT_ID", i), o);
          },
          calculateDistance: function e(t, i, o) {
            var n,
              a = Math.PI / 180,
              s = t.latitude * a,
              r = t.longitude * a,
              c = i.latitude * a,
              l =
                Math.pow(Math.sin((s - c) / 2), 2) +
                Math.cos(s) *
                  Math.cos(c) *
                  Math.pow(Math.sin((r - i.longitude * a) / 2), 2);
            return (
              ("metric" === o ? 6378.14 : 3959) *
              (2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)))
            );
          },
          updateLocationDistances: function t(i) {
            var o = this.$modal.find("[data-unit-system]").data("unit-system"),
              n = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var t = this,
                a = {
                  latitude: parseFloat(e(this).data("latitude")),
                  longitude: parseFloat(e(this).data("longitude")),
                };
              if (a.latitude && a.longitude) {
                var s = n.functions.calculateDistance(i, a, o).toFixed(1);
                e(this).html(s),
                  setTimeout(function () {
                    e(t)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              e(this).attr("data-distance", "true");
            });
          },
          updateContent: function t(n, a, s, r, l) {
            var d = this;
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]"
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background"
              ),
              e(".store-availabilities-modal").remove(),
              s
                ? this.$container.hide()
                : l
                ? (this.$container.addClass(i).addClass(o),
                  this.$container.css(
                    "height",
                    this.$container.outerHeight() > 0
                      ? this.$container.outerHeight() + "px"
                      : "auto"
                  ))
                : (this.$container.addClass(i).addClass(o),
                  this.$container.css("height", "0px")),
              l &&
                this.functions.getAvailableStores.call(this, n, function (t) {
                  if (t.trim().length > 0 && !t.includes("NO_PICKUP")) {
                    d.$container.html(t),
                      d.$container.html(d.$container.children().first().html()),
                      d.$container
                        .find("[data-store-availability-modal-product-title]")
                        .html(a),
                      r &&
                        d.$container
                          .find(".store-availabilities-modal__variant-title")
                          .remove(),
                      d.$container.find(".cc-popup").appendTo("body"),
                      (d.$modal = e("body").find(
                        ".store-availabilities-modal"
                      ));
                    var o = new c(d.$modal, d.namespace);
                    if (
                      (d.$container.on(
                        "click",
                        "[data-store-availability-modal-open]",
                        function () {
                          return (
                            o.open(),
                            d.functions.getUserLocation().then(function (t) {
                              t &&
                                d.$modal.find('[data-distance="false"]')
                                  .length &&
                                d.functions.getAvailableStores.call(
                                  d,
                                  n,
                                  function (i) {
                                    d.$modal
                                      .find(".store-availabilities-list")
                                      .html(
                                        e(i)
                                          .find(".store-availabilities-list")
                                          .html()
                                      ),
                                      d.functions.updateLocationDistances.bind(
                                        d
                                      )(t);
                                  }
                                );
                            }),
                            !1
                          );
                        }
                      ),
                      d.$modal.on(
                        "click" + d.namespace,
                        ".cc-popup-close, .cc-popup-background",
                        function () {
                          o.close();
                        }
                      ),
                      s)
                    )
                      d.$container.slideDown(300);
                    else {
                      d.$container.removeClass(i);
                      var l = d.$container
                        .find(".store-availability-container")
                        .outerHeight();
                      d.$container.css("height", l > 0 ? l + "px" : "auto");
                    }
                  }
                });
          },
        }),
        this.onSectionLoad(t);
    }),
    r.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    });
  try {
    theme.shopifyFeatures = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent
    );
  } catch (l) {
    theme.shopifyFeatures = {};
  }
  (slate.a11y = {
    pageLinkFocus: function e(t) {
      var i = "js-focus-hidden";
      t.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(i)
        .one("blur", function e() {
          t.first().removeClass(i).removeAttr("tabindex");
        });
    },
    focusHash: function t() {
      var i = window.location.hash;
      i && document.getElementById(i.slice(1)) && this.pageLinkFocus(e(i));
    },
    bindInPageLinks: function t() {
      e("a[href*=#]").on(
        "click",
        function (t) {
          this.pageLinkFocus(e(t.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function t(i) {
      var o = i.namespace ? "focusin." + i.namespace : "focusin";
      i.$elementToFocus || (i.$elementToFocus = i.$container),
        i.$container.attr("tabindex", "-1"),
        i.$elementToFocus.focus(),
        e(document).on(o, function (e) {
          i.$container[0] === e.target ||
            i.$container.has(e.target).length ||
            i.$container.focus();
        });
    },
    removeTrapFocus: function t(i) {
      var o = i.namespace ? "focusin." + i.namespace : "focusin";
      i.$container &&
        i.$container.length &&
        i.$container.removeAttr("tabindex"),
        e(document).off(o);
    },
  }),
    (slate.cart = {
      cookiesEnabled: function e() {
        var t = navigator.cookieEnabled;
        return (
          t ||
            ((document.cookie = "testcookie"),
            (t = -1 !== document.cookie.indexOf("testcookie"))),
          t
        );
      },
    }),
    (slate.utils = {
      findInstance: function e(t, i, o) {
        for (var n = 0; n < t.length; n++) if (t[n][i] === o) return t[n];
      },
      removeInstance: function e(t, i, o) {
        for (var n = t.length; n--; )
          if (t[n][i] === o) {
            t.splice(n, 1);
            break;
          }
        return t;
      },
      compact: function e(t) {
        for (
          var i = -1, o = null == t ? 0 : t.length, n = 0, a = [];
          ++i < o;

        ) {
          var s = t[i];
          s && (a[n++] = s);
        }
        return a;
      },
      defaultTo: function e(t, i) {
        return null == t || t != t ? i : t;
      },
    }),
    (slate.rte = {
      wrapTable: function e(t) {
        var i = void 0 === t.tableWrapperClass ? "" : t.tableWrapperClass;
        t.$tables.wrap('<div class="' + i + '"></div>');
      },
      wrapIframe: function t(i) {
        var o = void 0 === i.iframeWrapperClass ? "" : i.iframeWrapperClass;
        i.$iframes.each(function () {
          e(this).wrap('<div class="' + o + '"></div>'), (this.src = this.src);
        });
      },
    }),
    (slate.Image = {
      preload: function e(t, i) {
        "string" == typeof t && (t = [t]);
        for (var o = 0; o < t.length; o++) {
          var n = t[o];
          this.loadImage(this.getSizedImageUrl(n, i));
        }
      },
      loadImage: function e(t) {
        new Image().src = t;
      },
      imageSize: function e(t) {
        var i = t.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );
        return i ? i[1] : null;
      },
      getSizedImageUrl: function e(t, i) {
        if (null === i) return t;
        if ("master" === i) return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (!o) return null;
        var n = t.split(o[0]),
          a = o[0];
        return this.removeProtocol(n[0] + "_" + i + a);
      },
      removeProtocol: function e(t) {
        return t.replace(/http(s)?:/, "");
      },
    }),
    (slate.Variants = (function () {
      function t(t) {
        (this.$container = t.$container),
          (this.product = t.product),
          (this.singleOptionSelector = t.singleOptionSelector),
          (this.originalSelectorId = t.originalSelectorId),
          (this.enableHistoryState = t.enableHistoryState),
          (this.currentVariant = this._getVariantFromOptions()),
          e(this.singleOptionSelector, this.$container).on(
            "change",
            this._onSelectChange.bind(this)
          );
      }
      return (
        (t.prototype = e.extend({}, t.prototype, {
          _getCurrentOptions: function t() {
            var i = e.map(
              e(this.singleOptionSelector, this.$container),
              function (t) {
                var i = e(t),
                  o = i.attr("type"),
                  n = {};
                return "radio" !== o && "checkbox" !== o
                  ? ((n.value = i.val()), (n.index = i.data("index")), n)
                  : !!i[0].checked &&
                      ((n.value = i.val()), (n.index = i.data("index")), n);
              }
            );
            return slate.utils.compact(i);
          },
          _getVariantFromOptions: function e() {
            var t = this._getCurrentOptions(),
              i = this.product.variants,
              o = !1;
            return (
              i.forEach(function (e) {
                var i = !0;
                t.forEach(function (t) {
                  i && (i = t.value === e[t.index]);
                }),
                  i && (o = e);
              }),
              o || null
            );
          },
          _onSelectChange: function t() {
            var i = this._getVariantFromOptions();
            this.$container.trigger({ type: "variantChange", variant: i }),
              i &&
                (e(window).trigger("cc-variant-updated", {
                  variant: i,
                  product: this.product,
                }),
                this._updateMasterSelect(i),
                this._updateImages(i),
                this._updatePrice(i),
                (this.currentVariant = i),
                this.enableHistoryState && this._updateHistoryState(i));
          },
          _updateImages: function e(t) {
            var i = t.featured_media || {},
              o = this.currentVariant.featured_media || {};
            t.featured_media &&
              i.id !== o.id &&
              this.$container.trigger({
                type: "variantImageChange",
                variant: t,
              });
          },
          _updatePrice: function e(t) {
            var i = !1;
            (t.price !== this.currentVariant.price ||
              t.compare_at_price !== this.currentVariant.compare_at_price ||
              t.unit_price_measurement !==
                this.currentVariant.unit_price_measurement ||
              (t.unit_price_measurement &&
                (t.unit_price !== this.currentVariant.unit_price ||
                  t.unit_price_measurement.reference_value !==
                    this.currentVariant.unit_price_measurement
                      .reference_value ||
                  t.unit_price_measurement.reference_unit !==
                    this.currentVariant.unit_price_measurement
                      .reference_unit))) &&
              (i = !0),
              i &&
                this.$container.trigger({
                  type: "variantPriceChange",
                  variant: t,
                });
          },
          _updateHistoryState: function e(t) {
            if (history.replaceState && t) {
              var i =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?variant=" +
                t.id;
              window.history.replaceState({ path: i }, "", i);
            }
          },
          _updateMasterSelect: function t(i) {
            var o = e(this.originalSelectorId, this.$container)[0];
            (o.value = i.id),
              o.dispatchEvent(
                new Event("change", { bubbles: !0, cancelable: !1 })
              );
          },
        })),
        t
      );
    })()),
    (theme.storageAvailable = function (e) {
      try {
        var t = window[e],
          i = "__storage_test__";
        return t.setItem(i, i), t.removeItem(i), !0;
      } catch (o) {
        return (
          o instanceof DOMException &&
          (22 === o.code ||
            1014 === o.code ||
            "QuotaExceededError" === o.name ||
            "NS_ERROR_DOM_QUOTA_REACHED" === o.name) &&
          0 !== t.length
        );
      }
    }),
    (theme.variants = {
      selectors: {
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productPrice: "[data-product-price]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        unitPrice: ".unit-price",
      },
      getBaseUnit: function e(t) {
        return 1 === t.unit_price_measurement.reference_value
          ? t.unit_price_measurement.reference_unit
          : t.unit_price_measurement.reference_value +
              t.unit_price_measurement.reference_unit;
      },
      updateAddToCartState: function t(i) {
        var o = i.variant;
        if (o)
          e(theme.variants.selectors.priceWrapper, this.$container).removeClass(
            "hide"
          );
        else {
          e(theme.variants.selectors.addToCart, this.$container).prop(
            "disabled",
            !0
          ),
            e(theme.variants.selectors.addToCartText, this.$container).html(
              theme.strings.unavailable
            ),
            e(theme.variants.selectors.priceWrapper, this.$container).addClass(
              "hide"
            );
          return;
        }
        o.available
          ? (e(theme.variants.selectors.addToCart, this.$container).prop(
              "disabled",
              !1
            ),
            e(theme.variants.selectors.addToCartText, this.$container).html(
              theme.strings.addToCart
            ),
            e("form", this.$container).removeClass("variant--unavailable"))
          : (e(theme.variants.selectors.addToCart, this.$container).prop(
              "disabled",
              !0
            ),
            e(theme.variants.selectors.addToCartText, this.$container).html(
              theme.strings.soldOut
            ),
            e("form", this.$container).addClass("variant--unavailable"));
        var n = e(".backorder", this.$container);
        if (n.length) {
          if (o && o.available) {
            var a = e(
              theme.variants.selectors.originalSelectorId +
                ' option[value="' +
                o.id +
                '"]',
              this.$container
            );
            o.inventory_management && "out" == a.data("stock")
              ? (n
                  .find(".backorder__variant")
                  .html(
                    this.productSingleObject.title +
                      (o.title.indexOf("Default") >= 0 ? "" : " - " + o.title)
                  ),
                n.show())
              : n.hide();
          } else n.hide();
        }
      },
      updateProductPrices: function t(i) {
        var o = i.variant,
          n = e(theme.variants.selectors.comparePrice, this.$container),
          a = n.add(theme.variants.selectors.comparePriceText, this.$container),
          s = e(theme.variants.selectors.productPrice, this.$container),
          r = e(theme.variants.selectors.unitPrice, this.$container);
        if (
          (s.html(
            '<span class="theme-money">' +
              theme.Shopify.formatMoney(o.price, theme.moneyFormat) +
              "</span>"
          ),
          o.compare_at_price > o.price
            ? (s.addClass("product-price__reduced"),
              n.html(
                '<span class="theme-money">' +
                  theme.Shopify.formatMoney(
                    o.compare_at_price,
                    theme.moneyFormat
                  ) +
                  "</span>"
              ),
              a.removeClass("hide"))
            : (s.removeClass("product-price__reduced"),
              n.html(""),
              a.addClass("hide")),
          o.unit_price_measurement)
        ) {
          var c = e('<div class="unit-price small-text">');
          e('<span class="unit-price__price theme-money">')
            .html(theme.Shopify.formatMoney(o.unit_price, theme.moneyFormat))
            .appendTo(c),
            e('<span class="unit-price__separator">')
              .html(theme.strings.unitPriceSeparator)
              .appendTo(c),
            e('<span class="unit-price__unit">')
              .html(theme.variants.getBaseUnit(o))
              .appendTo(c),
            r.length
              ? r.replaceWith(c)
              : e(
                  theme.variants.selectors.priceWrapper,
                  this.$container
                ).append(c);
        } else r.remove();
      },
    }),
    (theme.initAjaxAddToCartForm = function (t) {
      t.on("submit", function (t) {
        t.preventDefault();
        var i = e(this);
        i
          .addClass("add-in-progress")
          .find(":submit")
          .attr("disabled", "disabled")
          .each(function () {
            var t = e(this).is("button") ? "html" : "val";
            e(this)
              .data("previous-value", e(this)[t]())
              [t](theme.strings.addingToCart);
          }),
          e
            .post(
              theme.routes.cart_add_url + ".js",
              i.serialize(),
              function (t) {
                i
                  .find(":submit")
                  .each(function () {
                    var t = e(this),
                      o = e(this).is("button") ? "html" : "val";
                    t[o](theme.strings.addedToCart),
                      setTimeout(function () {
                        t.removeAttr("disabled")[o](t.data("previous-value")),
                          i.removeClass("add-in-progress");
                      }, 1e3);
                  })
                  .first(),
                  e.get(theme.routes.search_url, function (t) {
                    for (
                      var i = [
                          ".page-header .header-cart",
                          ".docked-navigation-container .header-cart",
                        ],
                        o = e(e.parseHTML("<div>" + t + "</div>")),
                        n = 0;
                      n < i.length;
                      n++
                    ) {
                      var a = i[n],
                        s = o.find(a).clone();
                      e(a).replaceWith(s);
                    }
                  }),
                  e.colorbox.close(),
                  (theme.productData = theme.productData || {}),
                  theme.productData[t.product_id] ||
                    (theme.productData[t.product_id] = JSON.parse(
                      document.querySelector(".ProductJson-" + t.product_id)
                        .innerHTML
                    ));
                for (
                  var o, n = null, a = 0;
                  a < theme.productData[t.product_id].variants.length;
                  a++
                ) {
                  var s = theme.productData[t.product_id].variants[a];
                  s.id == t.variant_id && (n = s);
                }
                var r = "";
                t.original_line_price > t.final_line_price
                  ? ((r +=
                      '<span class="cart-summary__price-reduced product-price__reduced theme-money">' +
                      theme.Shopify.formatMoney(
                        t.final_line_price,
                        theme.moneyFormat
                      ) +
                      "</span>"),
                    (r +=
                      '<span class="cart-summary__price-compare product-price__compare theme-money">' +
                      theme.Shopify.formatMoney(
                        t.original_line_price,
                        theme.moneyFormat
                      ) +
                      "</span>"))
                  : (r +=
                      '<span class="theme-money">' +
                      theme.Shopify.formatMoney(
                        t.final_line_price,
                        theme.moneyFormat
                      ) +
                      "</span>");
                var c = "";
                if (
                  (t.quantity > 1 &&
                    (c =
                      ' <span class="cart-summary__quantity">' +
                      t.quantity +
                      "</span>"),
                  t.line_level_discount_allocations &&
                    t.line_level_discount_allocations.length > 0)
                ) {
                  r += '<ul class="cart-discount-list small-text">';
                  for (
                    var a = 0;
                    a < t.line_level_discount_allocations.length;
                    a++
                  ) {
                    var l = t.line_level_discount_allocations[a];
                    r += [
                      '<li class="cart-discount">',
                      '<div class="cart-discount__label">',
                      l.discount_application.title,
                      "</div>",
                      '<div class="cart-discount__amount theme-money">',
                      theme.Shopify.formatMoney(l.amount, theme.moneyFormat),
                      "</div>",
                      "</li>",
                    ].join("");
                  }
                  r += "</ul>";
                }
                var d = "";
                t.selling_plan_allocation &&
                  t.selling_plan_allocation.selling_plan.name &&
                  (d = [
                    '<div class="cart-summary__selling-plan ">',
                    t.selling_plan_allocation.selling_plan.name,
                    "</div>",
                  ].join(""));
                var h = "";
                if (n) {
                  var u = theme.productData[t.product_id].options;
                  h = '<div class="cart-summary__product__variants">';
                  for (var a = 0; a < n.options.length; a++)
                    0 > n.options[a].indexOf("Default Title") &&
                      ((h += '<div class="cart-summary__variant">'),
                      (h +=
                        '<span class="cart-summary__variant-label">' +
                        u[a] +
                        ":</span> "),
                      (h +=
                        '<span class="cart-summary__variant-value">' +
                        n.options[a] +
                        "</span>"),
                      (h += "</div>"));
                  h += "</div>";
                }
                n.featured_media
                  ? (o = slate.Image.getSizedImageUrl(
                      n.featured_media.preview_image.src,
                      "200x"
                    ))
                  : theme.productData[t.product_id].media.length > 0 &&
                    (o = slate.Image.getSizedImageUrl(
                      theme.productData[t.product_id].media[0].preview_image
                        .src,
                      "200x"
                    )),
                  e.getJSON(theme.routes.cart_url + ".js", function (i) {
                    var n = e(
                      [
                        '<div class="added-notice global-border-radius added-notice--pre-reveal">',
                        '<div class="added-notice__header">',
                        '<span class="added-notice__title">',
                        theme.strings.addedToCartPopupTitle,
                        "</span>",
                        '<a class="added-notice__close feather-icon" href="#" aria-label="',
                        theme.strings.close,
                        '">',
                        theme.icons.close,
                        "</a>",
                        "</div>",
                        '<div class="cart-summary global-border-radius">',
                        '<div class="cart-summary__product">',
                        '<div class="cart-summary__product-image"><img class="global-border-radius" src="',
                        o,
                        '" role="presentation" alt=""></div>',
                        '<div class="cart-summary__product__description">',
                        '<div class="cart-summary__product-title">',
                        theme.productData[t.product_id].title,
                        c,
                        "</div>",
                        h,
                        d,
                        '<div class="cart-summary__price">',
                        r,
                        "</div>",
                        "</div>",
                        "</div>",
                        "</div>",
                        '<div class="cart-summary__footer">',
                        '<div class="cart-summary__total-quantity-row">',
                        "<span>",
                        theme.strings.addedToCartPopupItems,
                        "</span>",
                        "<span>",
                        i.item_count,
                        "</span>",
                        "</div>",
                        '<div class="cart-summary__total-price-row">',
                        "<span>",
                        theme.strings.addedToCartPopupSubtotal,
                        "</span>",
                        '<span class="theme-money">',
                        theme.Shopify.formatMoney(
                          i.total_price,
                          theme.moneyFormat
                        ),
                        "</span>",
                        "</div>",
                        '<a href="',
                        theme.routes.cart_url,
                        '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">',
                        theme.strings.addedToCartPopupGoToCart,
                        "</a>",
                        "</div>",
                        "</div>",
                      ].join("")
                    );
                    n.appendTo("body"),
                      setTimeout(function () {
                        n.removeClass("added-notice--pre-reveal");
                      }, 10),
                      (theme.addedToCartNoticeHideTimeoutId = setTimeout(
                        function () {
                          n.find(".added-notice__close").trigger("click");
                        },
                        5e3
                      ));
                  });
              },
              "json"
            )
            .fail(function (t) {
              i.removeClass("add-in-progress");
              var o = i
                .find(":submit")
                .removeAttr("disabled")
                .each(function () {
                  var t = e(this);
                  t[t.is("button") ? "html" : "val"](t.data("previous-value"));
                })
                .first();
              void 0 !== t && t.responseJSON && t.responseJSON.description
                ? theme.showQuickPopup(t.responseJSON.description, o)
                : i.off("submit").submit();
            });
      }),
        e(document).off(".ajaxAddToCart"),
        e(document).on(
          "click.ajaxAddToCart",
          ".added-notice__close",
          function () {
            var t = e(this)
              .closest(".added-notice")
              .addClass("added-notice--pre-destroy");
            return (
              setTimeout(function () {
                t.remove();
              }, 500),
              !1
            );
          }
        ),
        e(document).on("mouseenter.ajaxAddToCart", ".header-cart", function () {
          clearTimeout(theme.addedToCartNoticeHideTimeoutId),
            e(".added-notice__close").trigger("click");
        });
    }),
    (theme.unloadAjaxAddToCartForm = function (e) {
      e.off("submit");
    }),
    e(function () {
      function t(e) {
        var t = {
          left: e.offset().left - parseFloat(e.css("margin-left")),
          top: e.offset().top - parseFloat(e.css("margin-top")),
          width: e.outerWidth(),
          height: e.outerHeight(),
        };
        return (
          (t.right = t.left + t.width),
          (t.bottom = t.top + t.height),
          e.hasClass("avoid-overlaps__item--gravity-left")
            ? (t.gravity = 0)
            : e.hasClass("avoid-overlaps__item--gravity-right")
            ? (t.gravity = 2)
            : (t.gravity = 1),
          t
        );
      }
      function i(e) {
        0 == e.newRect.gravity ||
          (2 == e.newRect.gravity
            ? ((e.newRect.right = e.newRect.left),
              (e.newRect.left = e.newRect.right - e.newRect.width))
            : ((e.newRect.left = e.newRect.left - e.newRect.width / 2),
              (e.newRect.right = e.newRect.left + e.newRect.width))),
          (e.newRect.top = e.newRect.top - e.newRect.height / 2),
          (e.newRect.bottom = e.newRect.top + e.newRect.height);
      }
      function o(e, t) {
        e.newRect.left < t.left + 10 &&
          ((e.newRect.left = t.left + 11),
          (e.newRect.right = e.newRect.left + e.newRect.width)),
          e.newRect.top < t.top + 10 &&
            ((e.newRect.top = t.top + 11),
            (e.newRect.bottom = e.newRect.top + e.newRect.height)),
          e.newRect.right > t.right - 10 &&
            ((e.newRect.right = t.right - 11),
            (e.newRect.left = e.newRect.right - e.newRect.width)),
          e.newRect.bottom > t.bottom - 10 &&
            ((e.newRect.bottom = t.bottom - 11),
            (e.newRect.top = e.newRect.bottom - e.newRect.height));
      }
      function n(e, t) {
        return !(
          e.right < t.left ||
          e.left > t.right ||
          e.bottom < t.top ||
          e.top > t.bottom
        );
      }
      function a(e, t) {
        return !(
          e.right + 10 < t.left ||
          e.left - 10 > t.right ||
          e.bottom + 10 < t.top ||
          e.top - 10 > t.bottom
        );
      }
      function s(e, t) {
        var i =
            t.left + (t.right - t.left) / 2 - (e.left + (e.right - e.left) / 2),
          o = t.top + (t.bottom - t.top) / 2 - (e.top + (e.bottom - e.top) / 2);
        return Math.abs(i) > Math.abs(o)
          ? i > 0
            ? [1, 0, 2, 3]
            : [3, 0, 2, 1]
          : o > 0
          ? [2, 1, 3, 0]
          : [0, 1, 3, 2];
      }
      function r(t, i, o, a, s) {
        var r = e.extend({}, t.newRect);
        switch (i) {
          case 0:
            (r.bottom = o.newRect.top - 11), (r.top = r.bottom - r.height);
            break;
          case 1:
            (r.left = o.newRect.right + 11), (r.right = r.left + r.width);
            break;
          case 2:
            (r.top = o.newRect.bottom + 11), (r.bottom = r.top + r.height);
            break;
          case 3:
            (r.right = o.newRect.left - 11), (r.left = r.right - r.width);
        }
        for (
          var c,
            l,
            d =
              ((c = r),
              (l = a),
              c.left >= l.left + 10 &&
                c.top >= l.top + 10 &&
                c.right <= l.right - 10 &&
                c.bottom <= l.bottom - 10),
            h = !1,
            u = 0;
          u < s.length;
          u++
        ) {
          var p = s[u];
          p.el[0] != t.el[0] && n(r, p.newRect) && (h = !0);
        }
        return !!d && !h && ((t.newRect = r), !0);
      }
      (theme.checkOverlaps = function () {
        e(".avoid-overlaps")
          .each(function () {
            var n = e(this),
              c = e(".avoid-overlaps__mobile-container", this),
              l = null;
            l = c.length && "relative" == c.css("position") ? t(c) : t(n);
            var d = e(this).find(".avoid-overlaps__item"),
              h = [],
              u = [],
              p = [];
            d.each(function () {
              var i = {
                el: e(this),
                newRect: t(e(this)),
                oldRect: t(e(this)),
                overlaps: !1,
              };
              h.push(i),
                e(this).hasClass("overlay") || p.push(i),
                "absolute" != e(this).css("position") ||
                  e(this).hasClass("overlay--bottom-wide") ||
                  e(this).hasClass("overlay--low-wide") ||
                  u.push(i);
            });
            for (var m = 0; m < u.length; m++) {
              var f = u[m];
              i(f), o(f, l);
            }
            for (var m = 0; m < h.length; m++)
              for (var f = h[m], g = 0; g < p.length; g++) {
                var v = p[g];
                if (v.el[0] != f.el[0])
                  for (
                    var y = s(f.newRect, v.newRect);
                    y.length > 0 && a(f.newRect, v.newRect);

                  ) {
                    var b = r(v, y.shift(), f, l, h);
                    v.overlaps = !b;
                  }
              }
            for (var g = 0; g < h.length; g++) {
              var k = h[g],
                w = k.newRect.left - k.oldRect.left,
                C = k.newRect.top - k.oldRect.top;
              k.el.css({
                marginLeft: 0 != w ? w : "",
                marginTop: 0 != C ? C : "",
              }),
                k.el.toggleClass("is-overlapping", k.overlaps);
            }
          })
          .addClass("avoid-overlaps--processed");
      }),
        theme.checkOverlaps(),
        e(document).on("shopify:section:load", theme.checkOverlaps),
        e(window).on("debouncedresize", theme.checkOverlaps);
    }),
    (theme.assessLoadedRTEImage = function (t) {
      var i = e(t).closest(".rte").width();
      if (e(t)[0].naturalWidth > i) {
        var o = e(t).parentsUntil(".rte").filter("p");
        o.length > 0
          ? o.addClass("expanded-width")
          : e(t).wrap('<p class="expanded-width"></p>');
      } else e(t).closest(".expanded-width").removeClass("expanded-width");
    }),
    (theme.assessRTEImagesOnLoad = function (t) {
      e(".rte--expanded-images img:not(.exp-loaded)", t).each(function () {
        var t = this,
          i = new Image();
        e(i).on("load.rteExpandedImage", function () {
          e(t).addClass("exp-loaded"), theme.assessLoadedRTEImage(t);
        }),
          (i.src = this.src),
          (i.complete || 4 === i.readyState) &&
            (e(i).off("load.rteExpandedImage"),
            e(t).addClass("exp-loaded"),
            theme.assessLoadedRTEImage(t));
      });
    }),
    theme.assessRTEImagesOnLoad(),
    e(window).on("debouncedresize", function () {
      e(".rte--expanded-images img.exp-loaded").each(function () {
        theme.assessLoadedRTEImage(this);
      });
    }),
    (theme.recentProductCacheExpiry = 6e5),
    (theme.recentProductHistoryCap = 12),
    (theme.recentProductsStorageKey = "theme.recent_products_v3"),
    (theme.addRecentProduct = function (t, i, o, n, a) {
      var s = t[i],
        r = t,
        c = n,
        l = a,
        d = o,
        h = e(
          '<div class="product-block product-block--recent-unloaded grid__item one-sixth medium--one-quarter small-down--one-whole">'
        ),
        u = new Date().getTime();
      s.timestamp && s.timestamp > u - theme.recentProductCacheExpiry
        ? h
            .append(theme.buildRecentProduct(s, c, l))
            .removeClass("product-block--recent-unloaded")
        : e.getJSON(s.url + ".js", function (e) {
            (s.title = e.title),
              (s.image =
                e.media && e.media.length ? e.media[0].preview_image.src : ""),
              (s.timestamp = u),
              window.localStorage.setItem(
                theme.recentProductsStorageKey,
                JSON.stringify(r)
              ),
              d.filter(".slick-initialized").slick("slickUnfilter"),
              h
                .append(theme.buildRecentProduct(s, c, l))
                .removeClass("product-block--recent-unloaded"),
              d
                .filter(".slick-initialized")
                .slick("slickFilter", ":not(.product-block--recent-unloaded)"),
              theme.initUniformHeightMonitor(
                d,
                ".product-block__image-container",
                ".product-block__image-container .image-one"
              );
          }),
        o.append(h),
        theme.assessRecentProductGrid(o);
    }),
    (theme.assessRecentProductGrid = function (t) {
      var i = t.children(),
        o = Math.max(i.length - 4, 0);
      if (o > 0) {
        i.slice(0, 3).removeClass("medium--hide");
        for (var n = 0; n < o; n++) e(i[n]).addClass("medium--hide");
      }
    }),
    (theme.onRecentProductImageLoad = function () {
      if (theme.settings.uniformProductGridImagesEnabled) {
        var t = e(this).closest(".uhm-active");
        t.length && t.data("uhm-callback")();
      }
    }),
    (theme.buildRecentProduct = function (t, i, o) {
      var n = e('<a class="recently-viewed-product plain-link">').attr({
          href: t.url,
          title: t.title,
        }),
        a = e('<div class="product-price small-text">');
      if (
        (t.priceVaries &&
          (e('<span class="product-price__from tiny-text">')
            .html(theme.strings.priceFrom)
            .appendTo(a),
          a.append(" ")),
        t.compareAtPrice > t.price
          ? (e('<span class="product-price__reduced theme-money">')
              .html(theme.Shopify.formatMoney(t.price, theme.moneyFormat))
              .appendTo(a),
            a.append(" "),
            e('<span class="product-price__compare theme-money">')
              .html(
                theme.Shopify.formatMoney(t.compareAtPrice, theme.moneyFormat)
              )
              .appendTo(a))
          : e('<span class="theme-money">')
              .html(theme.Shopify.formatMoney(t.price, theme.moneyFormat))
              .appendTo(a),
        t.unitPrice)
      ) {
        var s = e('<div class="unit-price tiny-text">');
        e('<span class="unit-price__price theme-money">')
          .html(theme.Shopify.formatMoney(t.unitPrice, theme.moneyFormat))
          .appendTo(s),
          e('<span class="unit-price__separator">')
            .html(theme.strings.unitPriceSeparator)
            .appendTo(s),
          e('<span class="unit-price__unit">')
            .html(t.unitPriceUnit)
            .appendTo(s),
          s.appendTo(a);
      }
      var r = e('<div class="product-block__image-container">').appendTo(n),
        c = e(
          '<div class="hover-images global-border-radius relative">'
        ).appendTo(r);
      return (
        e('<div class="image-one">')
          .append(
            e('<img role="presentation">')
              .on("load", theme.onRecentProductImageLoad)
              .attr({ src: t.image, alt: t.title })
          )
          .appendTo(c),
        i &&
          t.image2 &&
          (c.addClass("hover-images--two"),
          e('<div class="image-two">')
            .css("background-image", "url(" + t.image2 + ")")
            .appendTo(c)),
        !1 === t.available
          ? theme.settings.soldLabelEnabled &&
            e(
              '<span class="product-label product-label--sold-out global-border-radius"></span>'
            )
              .html(theme.strings.soldOut)
              .appendTo(c)
          : theme.settings.saleLabelEnabled &&
            t.compareAtPrice > t.price &&
            e(
              '<span class="product-label product-label--on-sale global-border-radius"></span>'
            )
              .html(theme.strings.onSale)
              .appendTo(c),
        e('<div class="product-block__title small-text">')
          .html(t.title)
          .appendTo(n),
        o &&
          e('<div class="product-block__vendor tiny-text">')
            .html(t.vendor)
            .appendTo(n),
        n.append(a),
        n
      );
    }),
    (theme.getRecentProducts = function () {
      var e = window.localStorage.getItem(theme.recentProductsStorageKey);
      if (e)
        try {
          return JSON.parse(e);
        } catch (t) {}
      return [];
    }),
    (theme.addToAndReturnRecentProducts = function (e) {
      for (var t = theme.getRecentProducts(), i = !0; i; ) {
        i = !1;
        for (var o = 0; o < t.length; o++)
          if (t[o].handle == e.handle) {
            t.splice(o, 1), (i = !0);
            break;
          }
      }
      for (
        e.timestamp = new Date().getTime(), t.push(e);
        t.length > theme.recentProductHistoryCap;

      )
        t.shift();
      return (
        window.localStorage.setItem(
          theme.recentProductsStorageKey,
          JSON.stringify(t)
        ),
        t
      );
    }),
    (theme.loadRecentlyViewed = function (t) {
      theme.peekCarousel.init(t, e(".grid", t), ".recentlyViewed", function () {
        return 768 > e(window).width();
      }),
        e(".grid", t)
          .filter(".slick-initialized")
          .slick("slickFilter", ":not(.product-block--recent-unloaded)"),
        theme.initUniformHeightMonitor(
          t,
          ".product-block__image-container",
          ".product-block__image-container .image-one"
        );
    }),
    (theme.unloadRecentlyViewed = function (t) {
      theme.destroyUniformHeightMonitor(t),
        theme.peekCarousel.destroy(
          t,
          e(".slick-initialized", t),
          ".recentlyViewed"
        );
    }),
    (theme.ProductMedia = new (function () {
      var t = this;
      (t._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            t._setupShopifyXr.bind(this)
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse(e(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (i, o) {
          var o = o || {},
            n = i;
          e(i).on(
            "mediaVisible",
            ".product-media--video-loaded, .product-media--model-loaded",
            function () {
              e(window).width() >= 768 && e(this).data("player").play(),
                e(this).hasClass("product-media--model") &&
                  e(".view-in-space", n).attr(
                    "data-shopify-model3d-id",
                    e(this).data("model-id")
                  );
            }
          ),
            e(i).on(
              "mediaHidden",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                e(this).data("player").pause();
              }
            ),
            o.onVideoVisible &&
              e(i).on(
                "mediaVisible",
                ".product-media--video-loaded",
                o.onVideoVisible
              ),
            o.onVideoHidden &&
              e(i).on(
                "mediaHidden",
                ".product-media--video-loaded",
                o.onVideoHidden
              ),
            e("model-viewer", i).each(function () {
              o.onModelViewerPlay &&
                e(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  o.onModelViewerPlay
                ),
                o.onModelViewerPause &&
                  e(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    o.onModelViewerPause
                  );
            }),
            e(i)
              .find(".product-media--video")
              .each(function (t) {
                var i = e(this).data("enable-video-looping"),
                  n = e(this).find("iframe, video")[0],
                  a = e(this);
                if ("VIDEO" === n.tagName)
                  window.Shopify.loadFeatures([
                    {
                      name: "video-ui",
                      version: "1.0",
                      onLoad: function () {
                        var t = { playerType: "html5", element: n };
                        (t.play = function () {
                          this.plyr.play();
                        }.bind(t)),
                          (t.pause = function () {
                            this.plyr.pause();
                          }.bind(t)),
                          (t.destroy = function () {
                            this.plyr.destroy();
                          }.bind(t)),
                          (t.plyr = new Shopify.Plyr(n, {
                            controls: [
                              "play",
                              "progress",
                              "mute",
                              "volume",
                              "play-large",
                              "fullscreen",
                            ],
                            loop: { active: i },
                            hideControlsOnPause: !0,
                            iconUrl:
                              "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                            tooltips: { controls: !1, seek: !0 },
                          })),
                          e(this)
                            .data("player", t)
                            .addClass("product-media--video-loaded"),
                          e(n).on("playing", function () {
                            e(".product-media").not(a).trigger("mediaHidden"),
                              a
                                .find(".plyr__controls")
                                .off(".themeMediaEventFix")
                                .on(
                                  "keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix keydown.themeMediaEventFix",
                                  function (e) {
                                    e.stopPropagation();
                                  }
                                ),
                              o.onPlyrPlay && o.onPlyrPlay(t);
                          }),
                          e(n).on("pause ended", function () {
                            a
                              .find(".plyr__controls")
                              .off(".themeMediaEventFix"),
                              o.onPlyrPause && o.onPlyrPause(t);
                          }),
                          o.onPlyrInit && o.onPlyrInit(t);
                      }.bind(this),
                    },
                  ]),
                    theme.loadStyleOnce(
                      "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"
                    );
                else if (
                  "IFRAME" === n.tagName &&
                  /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    n.src
                  )
                ) {
                  var s = window.onYouTubeIframeAPIReady,
                    r = function () {
                      var t = { playerType: "youtube", element: n },
                        s = e(this).data("video-id");
                      (t.player = new YT.Player(n, {
                        videoId: s,
                        events: {
                          onStateChange: function n(s) {
                            s.data === YT.PlayerState.ENDED &&
                              i &&
                              s.target.seekTo(0),
                              s.data === YT.PlayerState.PLAYING &&
                                (e(".product-media")
                                  .not(a)
                                  .trigger("mediaHidden"),
                                o.onYouTubePlay && o.onYouTubePlay(t)),
                              s.data === YT.PlayerState.PAUSED &&
                                s.data === YT.PlayerState.ENDED &&
                                o.onYouTubePause &&
                                o.onYouTubePause(t);
                          },
                        },
                      })),
                        (t.play = function () {
                          this.player.playVideo();
                        }.bind(t)),
                        (t.pause = function () {
                          this.player.pauseVideo();
                        }.bind(t)),
                        (t.destroy = function () {
                          this.player.destroy();
                        }.bind(t)),
                        e(this)
                          .data("player", t)
                          .addClass("product-media--video-loaded"),
                        o.onYouTubeInit && o.onYouTubeInit(t);
                    }.bind(this);
                  window.YT && window.YT.Player
                    ? r()
                    : ((window.onYouTubeIframeAPIReady = function () {
                        s && s(), r();
                      }),
                      theme.loadScriptOnce(
                        "https://www.youtube.com/iframe_api"
                      ));
                }
              }),
            e(i).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)",
              function (t) {
                var i = e(this).find("model-viewer")[0],
                  n = e(this),
                  a = "mediaVisibleInitial" != t.type;
                e(this).addClass("product-media--model-loading"),
                  theme.loadStyleOnce(
                    "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
                  ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        e(this).data("player", new Shopify.ModelViewerUI(i)),
                          e('<div class="theme-event-proxy">')
                            .on("mouseup", function (t) {
                              t.stopPropagation(),
                                t.preventDefault(),
                                e(t.currentTarget)
                                  .closest(".product-media")[0]
                                  .dispatchEvent(
                                    new MouseEvent("mouseup", { bubbles: !0 })
                                  );
                            })
                            .appendTo(
                              e(this).find(
                                ".shopify-model-viewer-ui__controls-overlay"
                              )
                            ),
                          e(this)
                            .find("model-viewer")
                            .on(
                              "shopify_model_viewer_ui_toggle_play",
                              function () {
                                e(this)
                                  .closest(".product-media")
                                  .on(
                                    "touchstart.themeModelViewerFix mousedown.themeModelViewerFix keydown.themeModelViewerFix",
                                    function (e) {
                                      e.stopPropagation();
                                    }
                                  );
                              }
                            )
                            .on(
                              "shopify_model_viewer_ui_toggle_pause",
                              function () {
                                e(this)
                                  .closest(".shopify-model-viewer-ui")
                                  .off(".themeMediaEventFix");
                              }
                            ),
                          e(this)
                            .find("model-viewer")
                            .on(
                              "shopify_model_viewer_ui_toggle_play",
                              function () {
                                e(".product-media")
                                  .not(n)
                                  .trigger("mediaHidden");
                              }
                            ),
                          e(this)
                            .addClass("product-media--model-loaded")
                            .removeClass("product-media--model-loading"),
                          o.onModelViewerInit && o.onModelViewerInit(i),
                          a && e(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              }
            ),
            e(".model-json", i).length &&
              (window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: t._setupShopifyXr.bind(e(".model-json", i)),
                },
              ]),
              e(document).on("shopify_xr_launch", function () {
                e(".product-media--video-loaded").each(function () {
                  e(this).data("player").pause();
                });
              })),
            setTimeout(
              function () {
                e(".product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial");
              }.bind(i),
              50
            );
        }),
        (this.destroy = function (t) {
          e(document).off("shopify_xr_launch"),
            e(t).off("mediaVisible mediaVisibleInitial mediaHidden"),
            e(
              ".product-media--video-loaded, .product-media--model-loaded",
              t
            ).each(function () {
              e(this).data("player").destroy();
            }),
            e(".product-media--video video", t).off("playing pause ended"),
            e("model-viewer", t).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
            );
        });
    })()),
    (theme.Header = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          (this.$nav = e(".site-nav", t)),
          (this.$navLinks = this.$nav.children(
            ".site-nav__item:not(.site-nav__more-links)"
          )),
          (this.$navMoreLinksLink = e(".site-nav__more-links", this.$nav)),
          (this.$navMoreLinksContainer = e(
            ".small-dropdown__container",
            this.$navMoreLinksLink
          )),
          (this.$navMoreLinksSubmenuContainer = e(
            ".site-nav__more-links .more-links__dropdown-container",
            this.$nav
          )),
          (this.search = {
            ongoingRequest: null,
            ongoingTimeoutId: -1,
            throttleMs: 500,
            searchUrlKey: "searchUrl",
            resultsSelector: ".search-bar__results",
            resultsLoadingClass: "search-bar--loading-results",
            resultsLoadedClass: "search-bar--has-results",
            loadingMessage: theme.strings.searchLoading,
            moreResultsMessage: theme.strings.searchMoreResults,
            emptyMessage: theme.strings.searchNoResults,
          }),
          e(this.$container).on(
            "click" + this.namespace,
            ".js-search-form-open",
            this.functions.searchFormOpen.bind(this)
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".js-search-form-focus",
            this.functions.searchFormFocus.bind(this)
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".js-search-form-close",
            this.functions.searchFormClose.bind(this)
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".js-mobile-menu-icon",
            this.functions.mobileMenuOpen.bind(this)
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".js-close-mobile-menu",
            this.functions.mobileMenuClose.bind(this)
          ),
          e(this.$container).on(
            "focusin" + this.namespace,
            ".search-bar",
            this.functions.searchFocusIn.bind(this)
          ),
          e(this.$container).on(
            "focusout" + this.namespace,
            ".search-bar",
            this.functions.searchFocusOut.bind(this)
          ),
          e(".search-bar.live-search", this.$container).length &&
            e(this.$container).on(
              "keyup" + this.namespace + " change" + this.namespace,
              '.search-bar.live-search input[name="q"]',
              this.functions.updateSearchResults.bind(this)
            ),
          this.functions.setSearchTabbing.bind(this)(),
          e(".focus-tint").on(
            "click" + this.namespace,
            this.functions.onFocusTintClick.bind(this)
          ),
          e("body").toggleClass(
            "header-has-messages",
            this.$container.find(".store-messages-bar").length > 0
          ),
          e(".js-messages-slider", this.$container).slick({
            infinite: !0,
            autoplay: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: !1,
            nextArrow: !1,
          }),
          e(".js-mobile-messages-slider", this.$container).slick({
            infinite: !0,
            autoplay: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: !0,
            prevArrow: !1,
            nextArrow: !1,
            responsive: [{ breakpoint: 767, settings: "unslick" }],
          }),
          e(window).on("debouncedresize" + this.namespace, function (t) {
            e(".js-mobile-messages-slider", this.$container).slick("resize");
          }),
          e(this.$container).on(
            "click" + this.namespace,
            '.mobile-site-nav__icon, .mobile-site-nav__link[href="#"]',
            function (t) {
              t.preventDefault(),
                e(this).siblings(".mobile-site-nav__menu").slideToggle(250),
                e(this).toggleClass("submenu-open");
            }
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".customer-account .customer-login",
            this.functions.loginOpen.bind(this)
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".customer-account .customer-register",
            this.functions.registerOpen.bind(this)
          ),
          this.$container.hasClass("docking-header") &&
            ((this.desktopHeaderWasDocked = !1),
            (this.$dockedDesktopContentsContainer = e(
              ".docked-navigation-container__inner",
              t
            )),
            (this.$dockedDesktopBaseContainer = e(
              ".docked-navigation-container",
              t
            )),
            (this.mobileHeaderWasDocked = !1),
            (this.$dockedMobileContentsContainer = e(
              ".docked-mobile-navigation-container__inner",
              t
            )),
            (this.$dockedMobileBaseContainer = e(
              ".docked-mobile-navigation-container",
              t
            )),
            e(this.functions.dockedNavCheck.call(this)),
            e(window).on(
              "scroll" + this.namespace,
              this.functions.dockedNavCheck.bind(this)
            ),
            e(window).on(
              "debouncedresize" + this.namespace,
              this.functions.dockedNavCheck.bind(this)
            ),
            e('<style id="themeDockedNavStyle">').appendTo("head"),
            e(this.functions.updateDockedNavHeightStyle.call(this)),
            e(window).on(
              "debouncedresize" + this.namespace,
              this.functions.updateDockedNavHeightStyle.bind(this)
            )),
          e(this.functions.menuLinkVisibilityCheck.call(this)),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.menuLinkVisibilityCheck.bind(this)
          ),
          e(this.$container).on(
            "mouseenter" + this.namespace,
            ".more-links--with-dropdown .site-nav__item",
            this.functions.onMoreLinksSubMenuActive.bind(this)
          ),
          (this.navHoverDelay = 250),
          (this.$navLastOpenDropdown = e()),
          e(this.$container).on(
            "mouseenter" + this.namespace + " mouseleave" + this.namespace,
            ".site-nav__item--has-dropdown",
            function (t) {
              var i = e(t.currentTarget);
              if ("mouseenter" == t.type) {
                clearTimeout(this.navOpenTimeoutId),
                  clearTimeout(i.data("navCloseTimeoutId"));
                var o = i.siblings(".open");
                o.not(this.$navLastOpenDropdown).removeClass("open"),
                  (this.$navLastOpenDropdown = i);
                var n = 0 == o.length ? 0 : this.navHoverDelay,
                  a = setTimeout(
                    function () {
                      i.addClass("open").siblings(".open").removeClass("open");
                      var e = i.children(
                        ".small-dropdown:not(.more-links-dropdown)"
                      );
                      if (e.length && i.parent().hasClass("site-nav")) {
                        var t = i.offset().left + e.outerWidth(),
                          o = "",
                          n = this.$container.outerWidth() - 10;
                        t > n && (o = "translateX(" + (n - t) + "px)"),
                          e.css("transform", o);
                      }
                    }.bind(this),
                    n
                  );
                (this.navOpenTimeoutId = a), i.data("navOpenTimeoutId", a);
              } else
                clearTimeout(i.data("navOpenTimeoutId")),
                  i.data(
                    "navCloseTimeoutId",
                    setTimeout(function () {
                      i.removeClass("open")
                        .children(".small-dropdown:not(.more-links-dropdown)")
                        .css("transform", "");
                    }, this.navHoverDelay)
                  );
              i.children("[aria-expanded]").attr(
                "aria-expanded",
                "mouseenter" == t.type
              );
            }.bind(this)
          ),
          e(this.$container).on(
            "keydown" + this.namespace,
            ".site-nav__item--has-dropdown > .site-nav__link",
            this.functions.dropdownLinkKeyPress.bind(this)
          ),
          e(this.$container).on(
            "touchstart" +
              this.namespace +
              " touchend" +
              this.namespace +
              " click" +
              this.namespace,
            ".site-nav__item--has-dropdown > .site-nav__link",
            function (t) {
              if ("touchstart" == t.type)
                e(this).data("touchstartedAt", t.timeStamp);
              else if ("touchend" == t.type) {
                if (t.timeStamp - e(this).data("touchstartedAt") < 1e3)
                  return (
                    e(this).data("touchOpenTriggeredAt", t.timeStamp),
                    e(this).parent().hasClass("open")
                      ? e(this).parent().trigger("mouseleave")
                      : (e(".site-nav__item.open").trigger("mouseleave"),
                        e(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                "click" == t.type &&
                e(this).data("touchOpenTriggeredAt") &&
                t.timeStamp - e(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          ),
          e(this.$container).on(
            "touchstart" + this.namespace,
            ".customer-account__parent-link",
            function () {
              e(this)
                .closest(".customer-account")
                .addClass("customer-account--using-touch");
            }
          ),
          e(this.$container).on(
            "click" + this.namespace,
            ".customer-account__parent-link",
            this.functions.onAccountIconClick.bind(this)
          ),
          e(".disclosure", this.$container).each(function () {
            e(this).data("disclosure", new theme.Disclosure(e(this)));
          });
      }),
        (this.functions = {
          onAccountIconClick: function t(i) {
            if (e(window).width() >= 768) {
              i.preventDefault();
              var o = e(i.target)
                .closest(".customer-account")
                .toggleClass("customer-account--reveal-menu")
                .hasClass("customer-account--reveal-menu");
              e(i.target)
                .closest(".customer-account__parent-link")
                .attr("aria-expanded", o);
            }
          },
          dropdownLinkKeyPress: function t(i) {
            if (13 == i.which) {
              if (
                e(i.target).closest(".site-nav__dropdown").length &&
                e(i.target).closest(".more-links").length
              )
                e(i.target).trigger("mouseenter");
              else {
                var o = e(i.target)
                  .closest(".site-nav__item--has-dropdown")
                  .toggleClass("open")
                  .hasClass("open");
                e(i.target).attr("aria-expanded", o);
              }
              return !1;
            }
          },
          setSearchTabbing: function t(i) {
            e(".search-bar", this.$container).each(function () {
              "none" == e(this).css("pointer-events")
                ? e(this).find("a, input, button").attr("tabindex", "-1")
                : e(this).find("a, input, button").removeAttr("tabindex");
            });
          },
          onMoreLinksSubMenuActive: function t(i) {
            this.$navMoreLinksSubmenuContainer.empty();
            var o = e(i.currentTarget).children(".site-nav__dropdown");
            if (o.length) {
              var n = o.clone();
              n
                .find(".mega-dropdown__container .one-third")
                .removeClass("one-third")
                .addClass("one-half"),
                n
                  .find(".mega-dropdown__container .one-quarter")
                  .removeClass("one-quarter")
                  .addClass("one-third"),
                n
                  .find(".site-nav__promo-container > .three-quarters")
                  .removeClass("three-quarters")
                  .addClass("two-thirds"),
                n
                  .find(".site-nav__promo-container > .one-quarter")
                  .removeClass("one-quarter")
                  .addClass("one-third"),
                n.appendTo(this.$navMoreLinksSubmenuContainer);
            }
            var a = this.$navMoreLinksSubmenuContainer.outerHeight() + 30;
            this.$navMoreLinksSubmenuContainer.parent().css("min-height", a),
              e(i.currentTarget)
                .removeClass("more-links__parent--inactive")
                .addClass("more-links__parent--active")
                .siblings()
                .removeClass("more-links__parent--active")
                .addClass("more-links__parent--inactive"),
              e(i.target).attr("aria-expanded", !0),
              e(i.target)
                .parent()
                .siblings()
                .find("a")
                .attr("aria-expanded", !1);
          },
          menuLinkVisibilityCheck: function t(i) {
            var o = this.$nav.width(),
              n = this.$navMoreLinksLink.width(),
              a = 0;
            if (
              (this.$navLinks.each(function () {
                a += e(this).width() + 4;
              }),
              a > o)
            ) {
              a = n;
              var s = this.$navMoreLinksContainer.empty();
              this.$navLinks.each(function () {
                (a += e(this).width() + 4) > o
                  ? (s.append(
                      e(this).clone().removeClass("site-nav__invisible")
                    ),
                    e(this)
                      .addClass("site-nav__invisible")
                      .find("a")
                      .attr("tabindex", "-1"))
                  : e(this)
                      .removeClass("site-nav__invisible")
                      .find("a")
                      .removeAttr("tabindex");
              }),
                this.$navMoreLinksLink.attr("role", "menu"),
                this.$navMoreLinksContainer.find("a").removeAttr("tabindex"),
                this.$navMoreLinksLink.removeClass("site-nav__invisible"),
                this.$navMoreLinksLink.toggleClass(
                  "more-links--with-dropdown",
                  this.$navMoreLinksLink.find(
                    ".small-dropdown:first, .mega-dropdown:first"
                  ).length > 0
                ),
                this.$navMoreLinksLink.toggleClass(
                  "more-links--with-mega-dropdown",
                  this.$navMoreLinksLink.find(".mega-dropdown:first").length > 0
                ),
                this.$navMoreLinksContainer
                  .find(".small-dropdown")
                  .css("transform", "");
            } else
              this.$navLinks.removeClass("site-nav__invisible"),
                this.$navMoreLinksLink.addClass("site-nav__invisible"),
                this.$navMoreLinksLink.removeAttr("role"),
                this.$navMoreLinksContainer.empty();
          },
          loginOpen: function e(t) {
            t.preventDefault(),
              theme.openPageContentInLightbox(theme.routes.account_login_url);
          },
          registerOpen: function e(t) {
            t.preventDefault(),
              theme.openPageContentInLightbox(
                theme.routes.account_register_url
              );
          },
          searchFormOpen: function t(i) {
            i.preventDefault(),
              i.stopPropagation(),
              e("body").addClass("search-bar-open"),
              e(
                '.search-bar:not(.mobile-menu-search):visible input[name="q"]',
                this.$container
              ).focus(),
              this.functions.setSearchTabbing.bind(this)();
          },
          searchFormFocus: function t(i) {
            e('.search-bar:visible input[name="q"]', this.$container).focus();
          },
          searchFormClose: function t(i) {
            e("body").removeClass("search-bar-open search-bar-in-focus"),
              this.functions.setSearchTabbing.bind(this)(),
              i &&
                i.target &&
                e(i.target).closest(".search-bar").prev("a").focus().blur();
          },
          searchFocusIn: function t(i) {
            clearTimeout(this.searchFocusOutTimeout),
              e("body").addClass("search-bar-in-focus");
          },
          searchFocusOut: function t(i) {
            this.searchFocusOutTimeout = setTimeout(function () {
              e("body").removeClass("search-bar-in-focus"),
                e(".search-bar").removeClass("search-bar--has-results");
            }, 10);
          },
          onFocusTintClick: function e(t) {
            return this.functions.searchFormClose.bind(this)(), !1;
          },
          mobileMenuOpen: function t(i) {
            e(".header-navigation", this.$container).addClass(
              "header-navigation--open"
            ),
              e(document.body, this.$container).addClass("mobile-menu-open");
          },
          mobileMenuClose: function t(i) {
            e(".header-navigation", this.$container).removeClass(
              "header-navigation--open"
            ),
              e(document.body, this.$container).removeClass("mobile-menu-open");
          },
          updateSearchResults: function t(i) {
            var o = e(i.target).closest("form"),
              n = o.closest(".search-bar"),
              a =
                o.attr("action") +
                (o.attr("action").indexOf("?") >= 0 ? "&" : "?") +
                o.serialize();
            a != o.data(this.search.searchUrlKey) &&
              (o.data(this.search.searchUrlKey, a),
              this.functions._abortSearch.bind(this)(),
              o.find('input[name="q"]').val().length < 3
                ? this.functions._searchResultsHide.bind(this)(n)
                : (n.addClass(this.search.resultsLoadingClass),
                  n
                    .find(this.search.resultsSelector)
                    .html(
                      '<div class="search-result search-result--loading">' +
                        this.search.loadingMessage +
                        "</div>"
                    ),
                  (this.search.ongoingTimeoutId = setTimeout(
                    this.functions._fetchResults.bind(this, o, a, n),
                    this.search.throttleMs
                  ))));
          },
          _abortSearch: function e() {
            this.search.ongoingRequest && this.search.ongoingRequest.abort(),
              clearTimeout(this.search.ongoingTimeoutId);
          },
          _fetchResults: function t(i, o, n) {
            var a, s;
            theme.shopifyFeatures.predictiveSearch
              ? ((a = theme.routes.search_url + "/suggest.json"),
                (s = {
                  q: i.find('input[name="q"]').val(),
                  resources: {
                    type: i.find('input[name="type"]').val(),
                    limit: 6,
                    options: { unavailable_products: "last" },
                  },
                }))
              : ((a = i.attr("action") + "?" + i.serialize() + "&view=json"),
                (s = null)),
              (this.search.ongoingRequest = e
                .ajax({
                  url: a,
                  data: s,
                  dataType: "json",
                  success: this.functions._searchResultsSuccess.bind(
                    this,
                    n,
                    o
                  ),
                })
                .fail(
                  function (e, t) {
                    console.log("Error fetching results"),
                      console.log(t),
                      this.functions._searchResultsHide.bind(this, e);
                  }.bind(this, n)
                )
                .always(
                  function () {
                    this.search.ongoingRequest = null;
                  }.bind(this)
                ));
          },
          _searchResultsSuccess: function t(i, o, n) {
            i.addClass(this.search.resultsLoadedClass).removeClass(
              this.search.resultsLoadingClass
            );
            var a = e("<div>"),
              s = i.hasClass("live-search--show-price"),
              r = i.hasClass("live-search--show-vendor");
            if (
              (n.resources.results.products &&
                n.resources.results.products.length > 0) ||
              (n.resources.results.pages &&
                n.resources.results.pages.length > 0) ||
              (n.resources.results.articles &&
                n.resources.results.articles.length > 0)
            ) {
              if (n.resources.results.products)
                for (var c = 0; c < n.resources.results.products.length; c++) {
                  var l,
                    d = n.resources.results.products[c],
                    h = e('<a class="search-result">').attr("href", d.url),
                    u = e('<div class="search-result__title">').appendTo(h);
                  if (
                    (e(
                      '<div class="search-result__title search-result__title--product">'
                    )
                      .text(d.title)
                      .appendTo(u),
                    r &&
                      e('<div class="search-result__vendor">')
                        .text(d.vendor)
                        .appendTo(u),
                    s)
                  ) {
                    var p = e(
                      '<div class="search-result__price product-price">'
                    ).appendTo(u);
                    parseFloat(d.price_min) != parseFloat(d.price_max) &&
                      p
                        .append(
                          e('<span class="product-price__from">').html(
                            theme.strings.priceFrom
                          )
                        )
                        .append(" "),
                      e('<span class="theme-money">')
                        .toggleClass(
                          "product-price__reduced",
                          parseFloat(d.compare_at_price_min) >
                            parseFloat(d.price_min)
                        )
                        .html(
                          theme.Shopify.formatMoney(
                            d.price_min,
                            theme.moneyFormat
                          )
                        )
                        .appendTo(p),
                      parseFloat(d.compare_at_price_min) >
                        parseFloat(d.price_min) &&
                        p
                          .append(" ")
                          .append(
                            e(
                              '<span class="product-price__compare theme-money">'
                            ).html(
                              theme.Shopify.formatMoney(
                                d.compare_at_price_min,
                                theme.moneyFormat
                              )
                            )
                          );
                  }
                  (l = d.image
                    ? e('<span class="search-result__image">').append(
                        e('<img role="presentation" alt="">').attr(
                          "src",
                          slate.Image.getSizedImageUrl(
                            d.image,
                            "100x100_crop_center"
                          )
                        )
                      )
                    : e('<span class="search-result__image">').append(
                        e('<span class="search-result__char">').html(d.title[0])
                      )),
                    h.prepend(l).appendTo(a);
                }
              if (n.resources.results.articles)
                for (var c = 0; c < n.resources.results.articles.length; c++) {
                  var l,
                    d = n.resources.results.articles[c],
                    h = e('<a class="search-result">')
                      .attr("href", d.url)
                      .append(
                        e('<span class="search-result__title">').text(d.title)
                      );
                  (l = d.image
                    ? e('<span class="search-result__image">').append(
                        e('<img role="presentation" alt="">').attr(
                          "src",
                          slate.Image.getSizedImageUrl(
                            d.image,
                            "100x100_crop_center"
                          )
                        )
                      )
                    : e('<span class="search-result__image">').append(
                        e('<span class="search-result__char">').html(d.title[0])
                      )),
                    h.prepend(l).appendTo(a);
                }
              if (n.resources.results.pages)
                for (var c = 0; c < n.resources.results.pages.length; c++) {
                  var d = n.resources.results.pages[c],
                    h = e('<a class="search-result">')
                      .attr("href", d.url)
                      .append(
                        e('<span class="search-result__title">').text(d.title)
                      ),
                    l = e('<span class="search-result__image">').append(
                      e('<span class="search-result__char">').html(d.title[0])
                    );
                  h.prepend(l).appendTo(a);
                }
              e('<a class="search-result search-result--more">')
                .attr("href", o)
                .html(this.search.moreResultsMessage)
                .appendTo(a);
            } else
              a.append(
                '<div class="search-result search-result--empty">' +
                  this.search.emptyMessage +
                  "</div>"
              );
            i.find(this.search.resultsSelector).html(a);
          },
          _searchResultsHide: function e(t) {
            t.removeClass(this.search.resultsLoadedClass)
              .removeClass(this.search.resultsLoadingClass)
              .find(this.search.resultsSelector)
              .empty();
          },
          dockedNavCheck: function t(i) {
            var o = e(window).scrollTop(),
              n =
                e(window).width() >= theme.dockedNavDesktopMinWidth &&
                this.$dockedDesktopBaseContainer.offset().top < o,
              a =
                e(window).width() < theme.dockedNavDesktopMinWidth &&
                this.$dockedMobileBaseContainer.offset().top < o;
            n
              ? this.$dockedDesktopBaseContainer.css(
                  "height",
                  this.$dockedDesktopContentsContainer.outerHeight()
                )
              : this.desktopHeaderWasDocked &&
                this.$dockedDesktopBaseContainer.css("height", ""),
              a
                ? this.$dockedMobileBaseContainer.css(
                    "height",
                    this.$dockedMobileContentsContainer.outerHeight()
                  )
                : this.mobileHeaderWasDocked &&
                  this.$dockedMobileBaseContainer.css("height", ""),
              this.$container.toggleClass("docked-header--dock", n || a),
              n != this.desktopHeaderWasDocked &&
                this.functions.menuLinkVisibilityCheck.bind(this)(),
              (this.desktopHeaderWasDocked = n),
              (this.mobileHeaderWasDocked = a);
          },
          updateDockedNavHeightStyle: function t() {
            var i = theme.dockedNavHeight() + 30;
            e("#themeDockedNavStyle").html(
              "@media (min-width:768px){.sticky-element{top:" +
                theme.dockedNavHeight() +
                "px;} .product-detail__detail.sticky-element{top:" +
                i +
                "px;}}"
            );
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(".focus-tint").off(this.namespace),
            e(window).off(this.namespace),
            e(".js-messages-slider", this.$container).slick("unslick"),
            e(".js-mobile-messages-slider", this.$container).slick("unslick"),
            e("#themeDockedNavStyle").remove(),
            e(".disclosure", this.$container).each(function () {
              e(this).data("disclosure").unload();
            });
        });
    })()),
    (theme.Footer = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          (this.$stickyFooter = e(".sticky-footer", t)),
          e("body").removeClass(
            "sticky-footer-not-visible sticky-footer-partly-visible sticky-footer-fully-visible sticky-footer-taller-than-page sticky-footer-scrolled-into"
          ),
          this.$stickyFooter.length
            ? (this.functions.stickyResize.bind(this)(),
              this.functions.stickyScroll.bind(this)(),
              e(window).on(
                "debouncedresize" + this.namespace,
                this.functions.stickyResize.bind(this)
              ),
              e(window).on(
                "scroll" + this.namespace,
                this.functions.stickyScroll.bind(this)
              ))
            : ((this.$footerInner = this.$container.find(
                ".page-footer__inner "
              )),
              this.functions.pushDown.call(this),
              e(window).on(
                "debouncedresize" + this.namespace,
                this.functions.pushDown.bind(this)
              )),
          e(".disclosure", this.$container).each(function () {
            e(this).data("disclosure", new theme.Disclosure(e(this)));
          });
      }),
        (this.functions = {
          pushDown: function t() {
            var i =
              e(window).height() -
              (this.$container.offset().top + this.$footerInner.outerHeight());
            i > 0
              ? this.$container.css("padding-top", i)
              : this.$container.css("padding-top", "");
          },
          stickyScroll: function t() {
            e("body").toggleClass(
              "sticky-footer-scrolled-into",
              e(window).scrollTop() > this.$container.offset().top
            );
          },
          stickyResize: function t() {
            var i = this.$stickyFooter.outerHeight(),
              o = this.$container.offset().top,
              n = o < e(window).height(),
              a = o + i < e(window).height(),
              s = i > e(window).height();
            e("body").toggleClass("sticky-footer-not-visible", !n),
              e("body").toggleClass("sticky-footer-partly-visible", n && !a),
              e("body").toggleClass("sticky-footer-fully-visible", a),
              e("body").toggleClass("sticky-footer-taller-than-page", s),
              this.$container.css("min-height", i);
          },
        }),
        (this.onSectionUnload = function () {
          e(window).off(this.namespace),
            e(".disclosure", this.$container).each(function () {
              e(this).data("disclosure").unload();
            });
        });
    })()),
    (theme.Product = new (function () {
      var t = e.extend({}, theme.variants.selectors, {
        productJson: "[data-product-json]",
        productMediaContainer: ".product-detail__images",
        productMedia: "[data-product-media]",
        productImages: "[data-product-image]",
        productMediaThumbnails: "[data-product-media-thumbnail]",
        singleOptionSelector: "[data-single-option-selector]",
        skuWrapper: ".sku-wrapper",
        sku: ".sku-wrapper__sku",
        styledSelect: ".selector-wrapper select",
        quantitySelect: ".quantity-proxy",
        storeAvailability: "[data-store-availability-container]",
      });
      (this.onSectionLoad = function (i) {
        if (
          ((this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          e(t.storeAvailability, i).length &&
            (this.storeAvailability = new theme.StoreAvailability(
              e(t.storeAvailability, i)[0]
            )),
          e(t.productJson, this.$container).html())
        ) {
          this.$container.attr("data-section-id"),
            (this.productSingleObject = JSON.parse(
              e(t.productJson, this.$container).html()
            ));
          var o = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: t.singleOptionSelector,
            originalSelectorId: t.originalSelectorId,
            product: this.productSingleObject,
          };
          (this.settings = {}),
            (this.settings.imageSize = "master"),
            (this.variants = new slate.Variants(o)),
            (this.$productMediaContainer = e(
              t.productMediaContainer,
              this.$container
            )),
            (this.$productMedia = e(t.productMedia, this.$container)),
            (this.$productImages = e(t.productImages, this.$container)),
            (this.$productMediaThumbnails = e(
              t.productMediaThumbnails,
              this.$container
            )),
            this.$container.on(
              "variantChange" + this.namespace,
              theme.variants.updateAddToCartState.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.namespace,
              theme.variants.updateProductPrices.bind(this)
            ),
            this.$container.find(t.skuWrapper) &&
              this.$container.on(
                "variantChange" + this.namespace,
                this.functions.updateSKU.bind(this)
              ),
            this.$productMediaThumbnails.length
              ? (this.$productMedia.length > 1 &&
                  (this.$container.on(
                    "click" + this.namespace,
                    t.productMediaThumbnails,
                    this.functions.updatePrimaryProductMediaFromThumbnailClick.bind(
                      this
                    )
                  ),
                  this.$container.on(
                    "variantImageChange" + this.namespace,
                    this.functions.updateProductMediaSlideshowFromVariantChange.bind(
                      this
                    )
                  )),
                this.$container.on(
                  "click" + this.namespace,
                  t.productImages,
                  this.functions.openGallery.bind(this)
                ))
              : (this.$productMedia.length > 1 &&
                  (this.$container.on(
                    "variantImageChange" + this.namespace,
                    this.functions.updateProductMediaColumn.bind(this)
                  ),
                  e(document).on(
                    "click" + this.namespace + " keydown" + this.namespace,
                    function () {
                      this.$productMedia
                        .not(".variant-dim--fixed")
                        .removeClass("variant-dim");
                    }.bind(this)
                  ),
                  e(window).on(
                    "scroll" +
                      this.namespace +
                      " ontouchstart" +
                      this.namespace,
                    function () {
                      this.$productMedia
                        .not(".variant-dim--fixed")
                        .removeClass("variant-dim");
                    }.bind(this)
                  ),
                  e(window).on(
                    "scroll" + this.namespace,
                    this.functions.notifyMediaOfVisibilityInColumn.bind(this)
                  ),
                  this.functions.notifyMediaOfVisibilityInColumn.bind(this)()),
                this.$container.on(
                  "click" + this.namespace,
                  t.productImages,
                  this.functions.openGallery.bind(this)
                )),
            (this.mediaSlideshowActive = !1),
            e(window).on(
              "debouncedresize" + this.namespace,
              this.functions.assessMediaSlideshow.bind(this)
            ),
            this.functions.assessMediaSlideshow.bind(this)(),
            theme.ProductMedia.init(this.$container, {
              onPlyrInit: function t(i) {
                var o = e(i.element).closest(".slick-initialized");
                o.length &&
                  theme.productGallerySlideshowTabFix(
                    o.slick("getSlick").$slides,
                    o.slick("getSlick").currentSlide
                  );
              },
              onYoutubeInit: function t(i) {
                var o = e(i.element).closest(".slick-initialized");
                o.length &&
                  theme.productGallerySlideshowTabFix(
                    o.slick("getSlick").$slides,
                    o.slick("getSlick").currentSlide
                  );
              },
              onModelViewerInit: function t(i) {
                var o = e(i.element).closest(".slick-initialized");
                o.length &&
                  theme.productGallerySlideshowTabFix(
                    o.slick("getSlick").$slides,
                    o.slick("getSlick").currentSlide
                  );
              },
            }),
            this.$container
              .find(".product-media")
              .trigger("mediaVisibleInitial"),
            theme.styleVariantSelectors(e(t.styledSelect, i), o.product),
            this.variants.product.variants.length > 1 &&
              e(window).trigger("cc-variant-updated", {
                variant: this.variants.currentVariant,
                product: this.productSingleObject,
              }),
            theme.select2.init(e(t.quantitySelect, i)),
            this.$container.on("click", ".js-size-chart-open", function (t) {
              t.preventDefault(), e("body").addClass("size-chart-is-open");
            }),
            this.$container.on("click", ".js-size-chart-close", function () {
              e("body").removeClass("size-chart-is-open");
            }),
            theme.initAjaxAddToCartForm(
              e("form.ajax-product-form", this.$container)
            ),
            theme.assessRTEImagesOnLoad(this.$container);
        }
      }),
        (this.functions = {
          updateSKU: function i(o) {
            var n = o.variant;
            n && n.sku
              ? (e(t.skuWrapper, this.$container).removeClass(
                  "sku-wrapper--empty"
                ),
                e(t.sku, this.$container).html(n.sku))
              : (e(t.skuWrapper, this.$container).addClass(
                  "sku-wrapper--empty"
                ),
                e(t.sku, this.$container).empty());
          },
          notifyMediaOfVisibilityInColumn: function t() {
            var i = e(window).scrollTop(),
              o = i + e(window).height();
            e(".product-media", this.$container).each(function () {
              var t = e(this).offset().top,
                n = t + e(this).outerHeight();
              (t > i && t < o) || (n > i && n < o)
                ? !e(this).hasClass("product-media--on-screen") &&
                  (e(this).addClass("product-media--on-screen"),
                  e(this).is(
                    ".product-media--model:not(.product-media--model-loaded)"
                  ) && e(this).trigger("mediaVisibleInitial"))
                : e(this).hasClass("product-media--on-screen") &&
                  e(this)
                    .removeClass("product-media--on-screen")
                    .trigger("mediaHidden");
            });
          },
          _updatePrimaryProductMediaFromThumbnail: function e(t) {
            var i = this.$productMedia
              .filter('[data-media-id="' + t.data("media-id") + '"]')
              .closest(".slick-slide")
              .data("slick-index");
            this.$productMediaContainer.slick("slickGoTo", i);
          },
          updatePrimaryProductMediaFromThumbnailClick: function t(i) {
            i.preventDefault(),
              this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(
                e(i.currentTarget)
              );
          },
          updateProductMediaSlideshowFromVariantChange: function t(i) {
            var o = i.variant,
              n = this.$productMedia.filter(function () {
                return e(this).data("media-id") == o.featured_media.id;
              });
            1 == n.length &&
              this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(
                n
              );
          },
          updateProductMediaColumn: function t(i) {
            var o = i.variant,
              n = this.$productMedia.filter(function () {
                return e(this).data("media-id") == o.featured_media.id;
              });
            1 == n.length &&
              (this.$productMediaContainer.hasClass("slick-slider")
                ? this.functions._updatePrimaryProductMediaFromThumbnail.bind(
                    this
                  )(n)
                : (clearTimeout(this.variantScrollTimeoutId),
                  (this.variantScrollTimeoutId = setTimeout(
                    function () {
                      var t = n.offset().top - theme.dockedNavHeight(),
                        i = n.closest(".product-detail"),
                        o =
                          i.offset().top +
                          i.height() -
                          i.find(".product-detail__detail").outerHeight() -
                          20;
                      e("html,body").animate(
                        { scrollTop: Math.min(t, o) },
                        500,
                        function () {
                          n.removeClass("variant-dim"),
                            this.$productImages
                              .not(n)
                              .addClass("variant-dim variant-dim--fixed"),
                            setTimeout(function () {
                              e(".variant-dim--fixed").removeClass(
                                "variant-dim--fixed"
                              );
                            }, 500);
                        }.bind(this)
                      );
                    }.bind(this),
                    25
                  ))));
          },
          assessMediaSlideshow: function t(i) {
            var o = e(window).width(),
              n = !1;
            if (
              (this.$productMediaContainer.children().length > 1 && (n = !0),
              o < 768 || e(".product-detail__thumbnails").length)
            ) {
              if (!this.mediaSlideshowActive) {
                var a = 0,
                  s = this.$productMediaContainer.data("featured-media-id");
                this.$productMediaContainer.data("featured-media-id", null),
                  (a = this.$productMediaContainer
                    .find('[data-media-id="' + s + '"]')
                    .parent()
                    .index());
                var r = this.$productMediaContainer.slick({
                  infinite: !1,
                  fade: !0,
                  arrows: !1,
                  dots: !1,
                  adaptiveHeight: !0,
                  prevArrow: theme.icons.slideshowPrevArrow,
                  nextArrow: theme.icons.slideshowNextArrow,
                  appendArrows: e(
                    ".slick-external-controls .slick-arrows",
                    this.$container
                  ),
                  appendDots: e(
                    ".slick-external-controls .slick-dots",
                    this.$container
                  ),
                  initialSlide: a,
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: { fade: !1, arrows: !0, dots: n },
                    },
                  ],
                });
                r.find(".product-media").trigger("mediaVisibleInitial"),
                  r.on("afterChange", function (t, i, o) {
                    var n = e(".product-media", i.$slides[o]);
                    e(".product-media").not(n).trigger("mediaHidden"),
                      n.trigger("mediaVisible");
                    var a = e("[data-product-image]", i.$slides[o]);
                    e(
                      '.product-detail__thumbnail[data-media-id="' +
                        a.data("media-id") +
                        '"]'
                    )
                      .addClass("thumb-active")
                      .siblings()
                      .removeClass("thumb-active"),
                      theme.productGallerySlideshowTabFix(i.$slides, o),
                      e(this)
                        .closest(".quickbuy-container")
                        .trigger("changedsize");
                  }),
                  theme.productGallerySlideshowTabFix(
                    r.slick("getSlick").$slides,
                    r.slick("getSlick").currentSlide
                  ),
                  (this.mediaSlideshowActive = !0);
              }
            } else
              this.mediaSlideshowActive &&
                (this.$productMediaContainer.slick("unslick"),
                (this.mediaSlideshowActive = !1));
          },
          openGallery: function t(i) {
            i.preventDefault();
            var o = document.querySelectorAll(".pswp")[0],
              n = [];
            this.$productImages.each(function (t) {
              e(this).data("image-index", t);
              var i = {
                  src: e(this).attr("href"),
                  w: e(this).data("image-w"),
                  h: e(this).data("image-h"),
                },
                o = e(this).find("img")[0];
              void 0 !== o.currentSrc && (i.msrc = o.currentSrc), n.push(i);
            });
            var a = {
              history: !1,
              captionEl: !1,
              shareEl: !1,
              fullscreenEl: !1,
            };
            (a.index = e(i.target).closest("a").data("image-index")),
              (a.getThumbBoundsFn = function (e) {
                var t = this.$productImages[e].getElementsByTagName("img")[0],
                  i = window.pageYOffset || document.documentElement.scrollTop,
                  o = t.getBoundingClientRect();
                return { x: o.left, y: o.top + i, w: o.width };
              }.bind(this)),
              (this.imageGallery = new PhotoSwipe(
                o,
                PhotoSwipeUI_Default,
                n,
                a
              )),
              this.imageGallery.init(),
              this.imageGallery.listen(
                "destroy",
                function () {
                  this.imageGallery = null;
                }.bind(this)
              );
            var s = this;
            this.imageGallery.listen("afterChange", function () {
              var t = this.currItem.src,
                i = s.$productImages.filter(function () {
                  return e(this).attr("href") == t;
                });
              s.functions._updatePrimaryProductMediaFromThumbnail.bind(s)(i);
            });
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(document).off(this.namespace),
            e(window).off(this.namespace),
            this.imageGallery && this.imageGallery.close(),
            this.storeAvailability && this.storeAvailability.onSectionUnload(),
            theme.ProductMedia.destroy(this.$container),
            this.$container
              .find(".slick-initialized")
              .slick("unslick")
              .off("afterChange"),
            this.$container.find(".clickybox-replaced").clickyBoxes("destroy"),
            theme.unloadAjaxAddToCartForm(
              e("form.ajax-product-form", this.$container)
            );
        });
    })()),
    (theme.Blog = new (function () {
      var t = {
        header: ".featured-blog__header, .blog-featured-image",
        headerImage: ".featured-blog__header-image, .blog-image",
        slideshow: ".js-content-products-slider .grid",
      };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          (this.$header = e(t.header, this.$container)),
          (this.$headerImage = e(t.headerImage, this.$container)),
          e(".js-content-products-slider .grid", this.$container).each(
            function (t, i) {
              theme.peekCarousel.init(
                this.$container,
                e(i),
                this.namespace,
                function () {
                  return !0;
                },
                !1,
                {
                  infinite: !1,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  swipeToSlide: !0,
                  dots: !1,
                  prevArrow: e(i)
                    .closest(".content-products")
                    .find(".content-products-controls .prev"),
                  nextArrow: e(i)
                    .closest(".content-products")
                    .find(".content-products-controls .next"),
                  responsive: [
                    {
                      breakpoint: e(".single-column-layout", this.$container)
                        .length
                        ? 768
                        : 960,
                      settings: { slidesToShow: 1 },
                    },
                  ],
                }
              ),
                theme.initUniformHeightMonitor(
                  e(i),
                  ".product-block__image-container",
                  ".product-block__image-container .image-one"
                );
            }.bind(this)
          ),
          this.functions.assessSection.bind(this)(),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.assessSection.bind(this)
          );
      }),
        (this.functions = {
          assessSection: function t(i) {
            if (768 > e(window).width()) this.$headerImage.css("height", "");
            else {
              var o = parseInt(this.$header.css("padding-top"));
              this.$headerImage.css(
                "height",
                e(window).height() - 2 * o - theme.dockedNavHeight()
              );
            }
          },
        }),
        (this.onSectionUnload = function (t) {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            theme.destroyUniformHeightMonitor(
              e(".js-content-products-slider .grid", this.$container)
            ),
            theme.peekCarousel.destroy(
              this.$container,
              e(".js-content-products-slider .grid", this.$container),
              this.namespace
            );
        });
    })()),
    (theme.Article = new (function () {
      var t = { slideshow: ".js-content-products-slider .grid" };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          e(".template-article .rte").width(),
          e(t.slideshow, this.$container).each(
            function (t, i) {
              theme.peekCarousel.init(
                this.$container,
                e(i),
                this.namespace,
                function () {
                  return !0;
                },
                !1,
                {
                  infinite: !1,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  swipeToSlide: !0,
                  dots: !1,
                  prevArrow: e(i)
                    .closest(".content-products")
                    .find(".content-products-controls .prev"),
                  nextArrow: e(i)
                    .closest(".content-products")
                    .find(".content-products-controls .next"),
                  responsive: [
                    {
                      breakpoint: e(".single-column-layout", this.$container)
                        .length
                        ? 768
                        : 960,
                      settings: { slidesToShow: 1 },
                    },
                  ],
                }
              ),
                theme.initUniformHeightMonitor(
                  e(i),
                  ".product-block__image-container",
                  ".product-block__image-container .image-one"
                );
            }.bind(this)
          ),
          theme.assessRTEImagesOnLoad(this.$container);
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            theme.destroyUniformHeightMonitor(e(t.slideshow, this.$container)),
            theme.peekCarousel.destroy(
              this.$container,
              e(t.slideshow, this.$container),
              this.namespace
            );
        });
    })()),
    (theme.Slideshow = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          (this.$slideshow = e(".js-slideshow-section", this.$container)),
          this.$slideshow.children().length,
          this.$slideshow.slick({
            infinite: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: !0,
            adaptiveHeight: !1,
            autoplay: this.$slideshow.data("autoplay"),
            autoplaySpeed: this.$slideshow.data("autoplayspeed"),
            prevArrow: e(
              ".full-width-slideshow-controls .prev",
              this.$container
            ),
            nextArrow: e(
              ".full-width-slideshow-controls .next",
              this.$container
            ),
          }),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.onResize.bind(this)
          ),
          theme.checkOverlaps && theme.checkOverlaps();
      }),
        (this.functions = {
          onResize: function e(t) {
            this.$slideshow.slick("setPosition");
          },
        }),
        (this.onBlockSelect = function (t) {
          this.$slideshow
            .slick("slickGoTo", e(t).data("slick-index"), !0)
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (e) {
          this.$slideshow.slick("slickPlay");
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            this.$slideshow.slick("unslick");
        });
    })()),
    (theme.Banner = new (function () {
      (this.onSectionLoad = theme.Slideshow.onSectionLoad),
        (this.onSectionUnload = theme.Slideshow.onSectionUnload),
        (this.onBlockSelect = theme.Slideshow.onBlockSelect),
        (this.onBlockDeselect = theme.Slideshow.onBlockDeselect),
        (this.functions = theme.Slideshow.functions);
    })()),
    (theme.StandoutCollection = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          theme.peekCarousel.init(
            this.$container,
            e(".js-standout-collection-slider", this.$container),
            this.namespace,
            function () {
              return !0;
            },
            !1,
            {
              infinite: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: !1,
              prevArrow: e(
                ".standout-collection-slider__controls .prev",
                this.$container
              ),
              nextArrow: e(
                ".standout-collection-slider__controls .next",
                this.$container
              ),
            }
          );
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            theme.peekCarousel.destroy(
              this.$container,
              e(".js-standout-collection-slider", this.$container),
              this.namespace
            );
        });
    })()),
    (theme.GetTheLook = new (function () {
      var t = {
        header: ".get-the-look__image-container",
        headerImage:
          ".get-the-look__image-container .placeholder-svg, .get-the-look__image-container .rimage-outer-wrapper",
        slideshow: ".js-get-the-look-slider",
        product: ".get-the-look__product:first",
      };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          (this.$header = e(t.header, this.$container)),
          (this.$headerImage = e(t.headerImage, this.$container)),
          (this.$slideshow = e(t.slideshow, this.$container)),
          (this.$firstProduct = e(t.product, this.$container)),
          theme.peekCarousel.init(
            this.$container,
            this.$slideshow,
            this.namespace,
            function () {
              return (
                this.$firstProduct.length &&
                0 == parseInt(this.$firstProduct.css("margin-right"))
              );
            }.bind(this)
          ),
          this.functions.assessSection.bind(this)(),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.assessSection.bind(this)
          );
      }),
        (this.functions = {
          assessSection: function t(i) {
            if (
              this.$firstProduct.length &&
              0 == parseInt(this.$firstProduct.css("margin-right"))
            )
              this.$headerImage.css("height", "");
            else {
              var o = parseInt(this.$header.css("margin-top"));
              this.$headerImage.css(
                "height",
                e(window).height() - 2 * o - theme.dockedNavHeight()
              );
            }
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            theme.peekCarousel.destroy(
              this.$container,
              this.$slideshow,
              this.namespace
            );
        });
    })()),
    (theme.PromotionalImages = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          e(this.functions.assessSection.call(this)),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.assessSection.bind(this)
          );
      }),
        (this.functions = {
          assessSection: function t(i) {
            e(window).width() >= 768
              ? e(".promotional-row").each(function () {
                  var t = 0;
                  e(this)
                    .find(".text_over_image .promotional-row__content")
                    .each(function () {
                      var i = e(this).outerHeight() + 60;
                      i > t && (t = i);
                    }),
                    e(this).find(".text_over_image").css("min-height", t);
                })
              : e(".promotional-row .text_over_image").css("min-height", "");
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace), e(window).off(this.namespace);
        });
    })()),
    (theme.FeaturedCollection = new (function () {
      var t = { slideshow: "[data-carousel-enabled]" };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          (this.$slideshow = e(t.slideshow, this.$container)),
          this.$slideshow.each(
            function (t, i) {
              theme.peekCarousel.init(
                this.$container,
                e(i),
                this.namespace,
                function () {
                  return !0;
                },
                !1,
                {
                  infinite: !1,
                  slidesToShow: this.$slideshow.data("slides-per-row"),
                  slidesToScroll: 1,
                  swipeToSlide: !0,
                  dots: !1,
                  prevArrow: e(
                    ".featured-collection-controls .prev",
                    this.$container
                  ),
                  nextArrow: e(
                    ".featured-collection-controls .next",
                    this.$container
                  ),
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        nextArrow: !1,
                        prevArrow: !1,
                      },
                    },
                  ],
                }
              );
            }.bind(this)
          ),
          theme.initUniformHeightMonitor(
            this.$container,
            ".product-block__image-container",
            ".product-block__image-container .image-one"
          );
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            theme.destroyUniformHeightMonitor(this.$container),
            theme.peekCarousel.destroy(
              this.$container,
              this.$slideshow,
              this.namespace
            );
        });
    })()),
    (theme.ListCollections = new (function () {
      (this.onSectionLoad = function (t) {
        (this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          theme.assessRTEImagesOnLoad(this.$container),
          e(".js-list-collection-slider", this.$container).each(
            function (t, i) {
              theme.peekCarousel.init(
                this.$container,
                e(i),
                this.namespace,
                function () {
                  return !0;
                },
                !1,
                {
                  infinite: !0,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: !1,
                  prevArrow: e(i)
                    .siblings(".standout-collection-slider__controls")
                    .children(".prev"),
                  nextArrow: e(i)
                    .siblings(".standout-collection-slider__controls")
                    .children(".next"),
                  responsive: [
                    { breakpoint: 768, settings: { slidesToShow: 1 } },
                  ],
                }
              );
            }.bind(this)
          );
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            theme.peekCarousel.destroy(
              this.$container,
              e(".js-list-collection-slider", this.$container),
              this.namespace
            );
        });
    })()),
    (theme.CollectionTemplate = new (function () {
      var t = {
        sortBy: 'select[name="sort_by"]',
        styledSelect: ".styled-dropdown select",
        filterSelects: ".filter select",
        revealFilterButtons: ".collection-filter-control button",
        closeFilterButton: ".collection-filters-container__close",
        productsContainer: ".collection-product-list",
        ajaxProductsContainer: "[data-ajax-products]",
      };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          this.$container.on(
            "change" + this.namespace,
            t.sortBy,
            this.functions.onSortByChange.bind(this)
          ),
          (this.$filters = this.$container.find(t.filterSelects)),
          this.$filters.on(
            "change" + this.namespace,
            this.functions.onFilterChange.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            t.revealFilterButtons,
            this.functions.filterReveal.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            t.closeFilterButton,
            this.functions.filterClose.bind(this)
          ),
          theme.select2.init(e(t.styledSelect, i)),
          (this.$ajaxProductsContainer = e(t.ajaxProductsContainer, i)),
          this.$ajaxProductsContainer.data("ajax-products") &&
            e(window).on(
              "popstate" + this.namespace,
              this.functions.onWindowPopState.bind(this)
            ),
          (this.$productsContainer = e(t.productsContainer, i)),
          theme.initUniformHeightMonitor(
            this.$productsContainer,
            ".product-block__image-container",
            ".product-block__image-container .image-one"
          );
      }),
        (this.functions = {
          onWindowPopState: function e(t) {
            "themeChangeUrl" == t.originalEvent.state && location.reload();
          },
          changeUrl: function i(o) {
            if (this.$ajaxProductsContainer.data("ajax-products")) {
              930 >= e(window).width() &&
                e("html, body").animate(
                  { scrollTop: this.$ajaxProductsContainer.offset().top - 120 },
                  1e3
                ),
                this.$ajaxProductsContainer.css({
                  height: this.$ajaxProductsContainer.height(),
                  opacity: 0,
                });
              var n = o,
                a = this.$ajaxProductsContainer.css("transition-duration");
              (a = a.indexOf("ms") > -1 ? parseInt(a) : 1e3 * parseFloat(a)),
                setTimeout(
                  function () {
                    e.get(
                      o,
                      function (i) {
                        var o = e("<div>").append(e.parseHTML(i)),
                          a = o.find(t.ajaxProductsContainer).children();
                        this.$ajaxProductsContainer
                          .empty()
                          .append(a)
                          .css({ height: "", opacity: "" });
                        var s = o.find("title:first").text();
                        (document.title = s),
                          window.history.pushState("themeChangeUrl", s, n);
                      }.bind(this)
                    ).fail(function () {
                      window.location = n;
                    });
                  }.bind(this),
                  a
                );
            } else window.location = o;
          },
          onFilterChange: function t() {
            var i = this.$filters.first().data("filter-root"),
              o = [];
            if (
              (this.$filters.each(function () {
                e(this).val().length > 0 && o.push(e(this).val());
              }),
              (i += o.join("+")),
              location.search.indexOf("sort_by") > -1)
            ) {
              var n = location.search.match(/sort_by=([^$&]*)/);
              n && (i += "?sort_by=" + n[1]);
            }
            this.functions.changeUrl.bind(this)(i);
          },
          onSortByChange: function t(i) {
            var o = {};
            if (location.search.length)
              for (
                var n, a = 0, s = location.search.substr(1).split("&");
                a < s.length;
                a++
              )
                (n = s[a].split("=")).length > 1 &&
                  (o[decodeURIComponent(n[0])] = decodeURIComponent(n[1]));
            (o.sort_by = e(i.target).val()),
              this.functions.changeUrl.bind(this)(
                location.toString().split("?")[0] +
                  "?" +
                  e.param(o).replace(/\+/g, "%20")
              );
          },
          filterReveal: function t() {
            var i = e(".collection-filters-container")
                .removeClass("show-filters show-sort")
                .addClass(
                  "show-" + e(event.target).data("collection-filter-reveal")
                ),
              o = e(".collection-filter-control"),
              n = i.outerHeight() + o.outerHeight();
            (n += i.offset().top - o.offset().top),
              i.css("transform", "translate3d(0,0,0)");
          },
          filterClose: function t() {
            e(".collection-filters-container").css("transform", "");
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            this.$filters.off(this.namespace),
            e(t.styledSelect, this.$container).select2("destroy"),
            e(window).off(this.namespace),
            theme.destroyUniformHeightMonitor(this.$productsContainer);
        });
    })()),
    (theme.Cart = new (function () {
      (this.onSectionLoad = function (t) {
        if (
          ((this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          this.$container.on(
            "click" + this.namespace,
            ".js-shipping-calculator-trigger",
            function () {
              var t = e(this),
                i = t.parents(".shipping-calculator-container");
              i.toggleClass("calculator-open"),
                i.hasClass("calculator-open")
                  ? (t.text(
                      theme.strings.cart_shipping_calculator_hide_calculator
                    ),
                    i.children(".shipping-calculator").slideDown(250))
                  : (t.text(theme.strings.cart_shipping_calculator_title),
                    i.children(".shipping-calculator").slideUp(250));
            }
          ),
          this.$container.on(
            "click" + this.namespace,
            ".js-cart-notes-trigger",
            function () {
              var t = e(this),
                i = t.parent(".cart-notes-container");
              i.toggleClass("notes-open"),
                i.hasClass("notes-open")
                  ? (t.text(theme.strings.cart_general_hide_note),
                    i.children(".cart-notes").slideDown(250))
                  : (t.text(theme.strings.cart_general_show_note),
                    i.children(".cart-notes").slideUp(250));
            }
          ),
          theme.cartNoteMonitor.load(
            e('.cart-notes [name="note"]', this.$container)
          ),
          this.$container.data("ajax-update"))
        ) {
          var i = this.functions.updateCart.bind(this);
          this.$container.on(
            "keyup" + this.namespace + " change" + this.namespace,
            ".quantity__change input",
            function () {
              if (
                (!e(this).data("initial-value") ||
                  e(this).data("initial-value") != e(this).val()) &&
                0 != e(this).val().length &&
                "0" != e(this).val()
              ) {
                var t = e(this).attr("id");
                i(
                  { line: e(this).data("line"), quantity: e(this).val() },
                  function () {
                    e("#" + t).focus();
                  }
                ),
                  e(this).data("previousValue", e(this).val());
              }
            }
          ),
            this.$container.on(
              "click" + this.namespace,
              ".quantity__minus, .quantity__plus",
              function (t) {
                var i = e(this)
                  .closest(".quantity__change")
                  .find(".quantity__number");
                return (
                  e(this).hasClass("quantity__minus")
                    ? i.val(parseInt(i.val()) - 1).trigger("change")
                    : i.val(parseInt(i.val()) + 1).trigger("change"),
                  !1
                );
              }
            );
        }
        this.$container
          .on(
            "focusin" + this.namespace + " click" + this.namespace,
            "input.quantity__number",
            function () {
              e(this).select();
            }
          )
          .on(
            "mouseup" + this.namespace,
            "input.quantity__number",
            function (e) {
              e.preventDefault();
            }
          ),
          e("#terms", t).length > 0 &&
            e(document).on(
              "click" + this.namespace,
              '[name="checkout"], a[href*="/checkout"]',
              function () {
                if (0 == e("#terms:checked").length)
                  return alert(theme.strings.cartTermsNotChecked), !1;
              }
            ),
          (this.$recentlyViewed = e(".recently-viewed", this.$container)),
          this.$recentlyViewed.length &&
            (this.functions.loadRecentlyViewed.bind(this)(),
            theme.loadRecentlyViewed(this.$recentlyViewed));
      }),
        (this.functions = {
          loadRecentlyViewed: function e(t) {
            if (theme.storageAvailable("localStorage")) {
              var i = theme.getRecentProducts();
              if (i.length) {
                var o = this.$recentlyViewed.data("exclude"),
                  n = [];
                o.length && (n = o.split(","));
                for (
                  var a = this.$recentlyViewed.find(".grid"),
                    s = 0,
                    r = 0,
                    c = this.$recentlyViewed.data("show-vendor"),
                    l = this.$recentlyViewed.data("show-hover-image");
                  s < 6 && r < i.length;

                ) {
                  for (var d = !0, h = 0; h < n.length; h++)
                    if (i[r].handle == n[h]) {
                      d = !1;
                      break;
                    }
                  d && (s++, theme.addRecentProduct(i, r, a, l, c)), r++;
                }
                s > 0 && this.$recentlyViewed.removeClass("hidden");
              }
            }
          },
          updateCart: function t(i, o) {
            var n = this;
            n.cartXhr && n.cartXhr.abort(),
              n.cartRefreshXhr && n.cartRefreshXhr.abort(),
              (n.cartXhr = e.ajax({
                type: "POST",
                url: theme.routes.cart_change_url + ".js",
                data: i,
                dataType: "json",
                success: function t(i) {
                  n.cartRefreshXhr && n.cartRefreshXhr.abort(),
                    (n.cartRefreshXhr = e.ajax({
                      type: "GET",
                      url: theme.routes.cart_url + "?view=ajax",
                      success: function t(i) {
                        var n = [".cart-items", ".subtotal-row"],
                          a = e("<div>" + i + "</div>");
                        a.find(".fade-in").removeClass("fade-in");
                        for (var s = 0; s < n.length; s++)
                          e('[data-section-type="cart"] ' + n[s]).html(
                            a.find(n[s]).html()
                          );
                        o();
                      },
                      error: function e(t) {
                        "abort" != t.statusText &&
                          (console.log("Error refreshing page"),
                          console.log(t));
                      },
                      complete: function e() {
                        n.cartRefreshXhr = null;
                      },
                    }));
                },
                error: function e(t) {
                  console.log("Error processing update"), console.log(t);
                },
              }));
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(document).off(this.namespace),
            this.$recentlyViewed.length &&
              theme.unloadRecentlyViewed(this.$recentlyViewed),
            theme.cartNoteMonitor.unload(
              e('.cart-notes [name="note"]', this.$container)
            );
        });
    })()),
    (theme.ImageWithText = new (function () {
      (this.onSectionLoad = function (t) {
        function i(e) {
          var t = this.$image.height() / this.$image.width(),
            i = this.$imageContainer.outerWidth() * t;
          this.$imageContainer.toggleClass(
            "image-with-text__image--inset",
            i < this.$text.outerHeight()
          );
        }
        (this.namespace = theme.namespaceFromSection(t)),
          (this.$container = e(t)),
          (this.$imageContainer = e(".image-with-text__image", t)),
          (this.$image = e(".image-with-text__image .rimage__image", t)),
          (this.$text = e(".image-with-text__content", t)),
          e(window).on("debouncedresize" + this.namespace, i.bind(this)),
          e(i.call(this));
      }),
        (this.onSectionUnload = function () {
          e(window).off(this.namespace);
        });
    })()),
    (theme.FeaturedProduct = new (function () {
      (this.onSectionLoad = function (t) {
        (this.namespace = theme.namespaceFromSection(t)),
          (this.$container = e(t)),
          (this.$row = e(".featured-product-section", t)),
          (this.$imageOuterContainer = e(".featured-product-image", t)),
          (this.$mediaContainer = e(
            ".featured-product-image-link, .product-media-wrapper",
            t
          )),
          (this.$media = e(".product-media", t)),
          this.$media.length && theme.ProductMedia.init(this.$container),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.assessInset.bind(this)
          ),
          e(this.functions.assessInset.call(this));
      }),
        (this.functions = {
          assessInset: function e(t) {
            var i =
                this.$mediaContainer.height() / this.$mediaContainer.width(),
              o = Math.round(this.$imageOuterContainer.outerWidth() * i);
            this.$imageOuterContainer.toggleClass(
              "featured-product-image--inset",
              o < this.$row.height()
            );
          },
        }),
        (this.onSectionUnload = function () {
          this.$media.length && theme.ProductMedia.destroy(this.$container),
            e(window).off(this.namespace);
        });
    })()),
    (theme.RecentlyViewed = new (function () {
      var t = { recentlyViewed: ".recently-viewed" };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          (this.$recentlyViewed = e(t.recentlyViewed, this.$container)),
          this.$recentlyViewed.length &&
            (this.functions.loadRecentlyViewed.bind(this)(),
            theme.loadRecentlyViewed(this.$recentlyViewed));
      }),
        (this.functions = {
          loadRecentlyViewed: function e(t) {
            if (theme.storageAvailable("localStorage")) {
              var i = {
                handle: this.$recentlyViewed.data("handle"),
                url: this.$recentlyViewed.data("url").split("?")[0],
                title: this.$recentlyViewed.data("title"),
                vendor: this.$recentlyViewed.data("vendor"),
                available: this.$recentlyViewed.data("available"),
                image: this.$recentlyViewed.data("image"),
                image2: this.$recentlyViewed.data("image2"),
                price: this.$recentlyViewed.data("price"),
                priceVaries: this.$recentlyViewed.data("price-varies"),
                compareAtPrice: this.$recentlyViewed.data("price-compare"),
              };
              this.$recentlyViewed.data("unit-price-price") &&
                ((i.unitPrice = this.$recentlyViewed.data("unit-price-price")),
                (i.unitPriceUnit =
                  this.$recentlyViewed.data("unit-price-unit")));
              var o = theme.addToAndReturnRecentProducts(i);
              if (o.length > 1)
                for (
                  var n = this.$recentlyViewed
                      .removeClass("hidden")
                      .find(".grid"),
                    a = this.$recentlyViewed.data("show-vendor"),
                    s = this.$recentlyViewed.data("show-hover-image"),
                    r = Math.max(0, o.length - 6 - 1),
                    c = o.length - 1,
                    l = r;
                  l < c;
                  l++
                )
                  theme.addRecentProduct(o, l, n, s, a);
            }
          },
        }),
        (this.onSectionUnload = function () {
          this.$recentlyViewed.length &&
            theme.unloadRecentlyViewed(this.$recentlyViewed);
        });
    })()),
    (theme.SearchTemplate = new (function () {
      var t = { productsContainer: ".search-results-list" };
      (this.onSectionLoad = function (i) {
        (this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          (this.$productsContainer = e(t.productsContainer, i)),
          theme.initUniformHeightMonitor(
            this.$productsContainer,
            ".product-block__image-container",
            ".product-block__image-container .image-one"
          );
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            theme.destroyUniformHeightMonitor(this.$productsContainer);
        });
    })()),
    (theme.Testimonials = new (function () {
      (this.onSectionLoad = function (t) {
        if (
          ((this.$container = e(t)),
          (this.namespace = theme.namespaceFromSection(t)),
          (this.$slideshow = e(".js-testimonials-section", this.$container)),
          this.$slideshow.children().length,
          this.$slideshow.children().length > 1)
        )
          var i = !0;
        this.$slideshow.slick({
          infinite: !0,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: !0,
          adaptiveHeight: !1,
          autoplay: this.$slideshow.data("autoplay"),
          autoplaySpeed: this.$slideshow.data("autoplayspeed"),
          arrows: !1,
          responsive: [
            { breakpoint: 768, settings: { slidesToShow: 1, dots: i } },
          ],
        }),
          e(window).on(
            "debouncedresize" + this.namespace,
            this.functions.onResize.bind(this)
          );
      }),
        (this.functions = {
          onResize: function e(t) {
            this.$slideshow.slick("setPosition");
          },
        }),
        (this.onBlockSelect = function (t) {
          this.$slideshow
            .slick("slickGoTo", e(t).data("slick-index"), !0)
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (e) {
          this.$slideshow.slick("slickPlay");
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            this.$slideshow.slick("unslick");
        });
    })()),
    (theme.Gallery = new (function () {
      var t = { slideshow: ".gallery--mobile-carousel" };
      (this.onSectionLoad = function (i) {
        if (
          ((this.$container = e(i)),
          (this.namespace = theme.namespaceFromSection(i)),
          ($slideshow = e(t.slideshow, this.$container)).length)
        ) {
          var o = function t() {
            var i = $slideshow.hasClass("slick-slider"),
              o = 768 > e(window).width();
            if (
              (o ||
                e(".lazyload--manual", $slideshow)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
              i && !o)
            ) {
              $slideshow.slick("unslick").off("init"),
                $slideshow
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var n = $slideshow.data("grid"),
                a = null;
              $slideshow.find(".gallery__item").each(function (t) {
                t % n == 0 &&
                  (a = e('<div class="gallery__row">').appendTo($slideshow)),
                  e(this).appendTo(a);
              });
            } else
              !i &&
                o &&
                ($slideshow.find(".gallery__item").appendTo($slideshow),
                $slideshow.find(".gallery__row").remove(),
                $slideshow
                  .on("init", function () {
                    e(".lazyload--manual", this)
                      .removeClass("lazyload--manual")
                      .addClass("lazyload");
                  })
                  .slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !0,
                    useTransform: !0,
                    dots: !0,
                    prevArrow: e(
                      ".gallery-slideshow-controls .prev",
                      this.$container
                    ),
                    nextArrow: e(
                      ".gallery-slideshow-controls .next",
                      this.$container
                    ),
                  }));
          };
          o(),
            e(window).on("debouncedresize.themeSection" + this.$container, o);
        }
      }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace),
            e(window).off(this.namespace),
            e(".slick-slider", this.$container).each(function () {
              e(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (t) {
          e(t)
            .closest(".slick-slider")
            .each(function () {
              e(this)
                .slick("slickGoTo", e(this).data("slick-index"))
                .slick("slickPause");
            });
        }),
        (this.onBlockDeselect = function (t) {
          e(t)
            .closest(".slick-slider")
            .each(function () {
              e(this).slick("slickPlay");
            });
        });
    })()),
    (theme._initCustomerAddressCountryDropdown = function () {
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        { hideElement: "AddressProvinceContainerNew" }
      ),
        e("#AddressCountryNew-modal").length &&
          new Shopify.CountryProvinceSelector(
            "AddressCountryNew-modal",
            "AddressProvinceNew-modal",
            { hideElement: "AddressProvinceContainerNew-modal" }
          ),
        e(".address-country-option").each(function () {
          var t = e(this).data("form-id");
          new Shopify.CountryProvinceSelector(
            "AddressCountry_" + t,
            "AddressProvince_" + t,
            { hideElement: "AddressProvinceContainer_" + t }
          );
        });
    }),
    (theme._setupCustomAddressModal = function () {
      var t = "-modal";
      e(
        ".lightbox-content form, .lightbox-content input[id], .lightbox-content select[id], .lightbox-content div[id]"
      ).each(function () {
        e(this).attr("id", e(this).attr("id") + t);
      }),
        e(".lightbox-content label[for]").each(function () {
          e(this).attr("for", e(this).attr("for") + t);
        }),
        e(".lightbox-content .address-country-option").each(function () {
          var i = e(this).data("form-id") + t;
          e(this).attr("data-form-id", i).data("form-id", i);
        }),
        theme._initCustomerAddressCountryDropdown();
    }),
    (theme.customerAddresses =
      ((t = e("#AddressNewForm")),
      void (
        !!t.length &&
        (Shopify && theme._initCustomerAddressCountryDropdown(),
        e(".address-new-toggle").on("click", function () {
          return (
            e.colorbox({
              transition: "fade",
              html: '<div class="lightbox-content">' + t.html() + "</div>",
              onComplete: theme._setupCustomAddressModal,
            }),
            !1
          );
        }),
        e(".address-edit-toggle").on("click", function () {
          var t = e(this).data("form-id");
          return (
            e.colorbox({
              transition: "fade",
              html:
                '<div class="lightbox-content">' +
                e("#EditAddress_" + t).html() +
                "</div>",
              onComplete: theme._setupCustomAddressModal,
            }),
            !1
          );
        }),
        e(".address-delete").on("click", function () {
          var t = e(this),
            i = t.data("form-id");
          confirm(
            t.data("confirm-message") ||
              "Are you sure you wish to delete this address?"
          ) &&
            Shopify.postLink(theme.routes.account_addresses_url + "/" + i, {
              parameters: { _method: "delete" },
            });
        }),
        e("#AddressNewForm .errors").length && e(".address-new-toggle").click(),
        e(".grid .address-card .errors").length &&
          e(".grid .address-card .errors")
            .first()
            .closest(".address-card")
            .find(".address-edit-toggle")
            .click())
      ))),
    (theme.customerLogin = (function () {
      var t = {
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink",
      };
      function i(t) {
        t.preventDefault(), o(e(this).closest(".container"));
      }
      function o(t) {
        e("[id=RecoverPasswordForm]", t).toggleClass("hide"),
          e("[id=CustomerLoginForm]", t).toggleClass("hide");
      }
      e(document).on("click", t.recoverPasswordForm, i),
        e(document).on("click", t.hideRecoverPasswordLink, i),
        e(t.recoverPasswordForm).length &&
          ("#recover" === window.location.hash && o(null),
          e(".reset-password-success").length &&
            e("#ResetSuccess").removeClass("hide"));
    })()),
    (theme.initUniformHeightMonitor = function (t, i, o) {
      theme.settings.uniformProductGridImagesEnabled &&
        (e(t)
          .addClass("uhm-active")
          .data(
            "uhm-callback",
            function (t, i) {
              var o = 0,
                n = e(t, this);
              e(i, this).each(function () {
                var t = e(this).height();
                t > o && (o = t);
              }),
                n.css("height", Math.ceil(o) + "px");
            }.bind(t, i, o)
          ),
        e(t).data("uhm-callback")(),
        e(window).on("debouncedresize", e(t).data("uhm-callback")));
    }),
    (theme.destroyUniformHeightMonitor = function (t) {
      theme.settings.uniformProductGridImagesEnabled &&
        e(t)
          .each(function () {
            e(window).off("debouncedresize", e(this).data("uhm-callback"));
          })
          .removeClass("uhm-active");
    }),
    (theme.icons = {
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      slideshowPrevArrow:
        '<button class="slick-prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
      slideshowNextArrow:
        '<button class="slick-next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>',
    }),
    (theme.openPageContentInLightbox = function (t) {
      e.get(t, function (t) {
        var i = e("#MainContent", e.parseHTML("<div>" + t + "</div>"));
        e.colorbox({
          transition: "fade",
          html: '<div class="lightbox-content">' + i.html() + "</div>",
          onComplete: function t() {
            e("#cboxContent .input-wrapper input").trigger("inputstateEmpty"),
              e("#cboxContent input[data-desktop-autofocus]").focus();
          },
        });
      });
    }),
    (theme.styleVariantSelectors = function (t, i, o) {
      var n = t.filter(function () {
        return void 0 !== e(this).data("listed");
      });
      if (
        (n.each(function () {
          e(this).clickyBoxes();
          var t = e(this)
            .closest(".selector-wrapper")
            .find(".variant-option-title");
          t.length &&
            (t.data("default-content", t.html()),
            e(this)
              .siblings(".clickyboxes")
              .on("change", function () {
                t.data(
                  "default-content",
                  e(this).find("a.active").data("value")
                );
              })
              .on("mouseenter", "a", function () {
                t.html(e(this).data("value"));
              })
              .on("mouseleave", "a", function () {
                t.html(t.data("default-content"));
              }));
        }),
        n.length > 0)
      )
        for (var a = 0; a < i.options.length; a++) {
          for (var s = {}, r = 0; r < i.variants.length; r++) {
            var c = i.variants[r];
            void 0 === s[c.options[a]] && (s[c.options[a]] = !1),
              c.available && (s[c.options[a]] = !0);
          }
          for (var l in s)
            s[l] ||
              e(t[a])
                .siblings(".clickyboxes")
                .find("li a")
                .filter(function () {
                  return e(this).attr("data-value") == l;
                })
                .addClass("unavailable");
        }
      t.not(n).each(function () {
        var t = {};
        o && (t.dropdownParent = e("#cboxWrapper")),
          theme.select2.init(e(this), t);
      }),
        o && e.colorbox.resize();
    }),
    (theme.select2 = {
      init: function t(i, o) {
        var n = { minimumResultsForSearch: 1 / 0 },
          a = {
            minimumResultsForSearch: 1 / 0,
            templateResult: theme.select2.swatchSelect2OptionTemplate,
            templateSelection: theme.select2.swatchSelect2OptionTemplate,
          };
        void 0 !== o && ((n = e.extend(n, o)), (a = e.extend(a, o))),
          i.each(function () {
            e(this).select2(e(this).data("colour-swatch") ? a : n);
          });
      },
      swatchSelect2OptionTemplate: function t(i) {
        return i.id
          ? e(
              [
                '<div class="swatch-option">',
                '<span class="swatch-option__nugget bg-',
                removeDiacritics(i.id)
                  .toLowerCase()
                  .replace(/'/g, "")
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-+/g, "-")
                  .replace(/-*$/, ""),
                '"></span>',
                '<span class="swatch-option__label">',
                i.text,
                "</span>",
                "</div>",
              ].join("")
            )
          : e(
              [
                '<div class="swatch-option swatch-option--all">',
                '<span class="swatch-option__label">',
                i.text,
                "</span>",
                "</div>",
              ].join("")
            );
      },
    }),
    (theme.namespaceFromSection = function (t) {
      return [".", e(t).data("section-type"), e(t).data("section-id")].join("");
    }),
    (theme.dockedNavDesktopMinWidth = 768),
    (theme.dockedNavHeight = function () {
      if (e(window).width() >= theme.dockedNavDesktopMinWidth) {
        if (e(".docked-navigation-container").length)
          return e(".docked-navigation-container__inner").height();
      } else if (e(".docked-mobile-navigation-container").length)
        return e(".docked-mobile-navigation-container__inner").height();
      return 0;
    }),
    (theme.resizeAccent = function () {
      var t = 0,
        i = e(".accent-background").next();
      if (i.length) {
        var o = parseInt(i.css("margin-top"));
        "shopify-section-banner" !== i[0].id ||
          i.children().length ||
          i.text().trim().length ||
          (i = i.next()),
          (t = i.find(".sticky-element").length
            ? Math.round(i.find(".sticky-element").outerHeight() / 2 + o)
            : Math.round(i.outerHeight() / 2 + o)),
          e(".accent-background").css("height", t);
      } else t = "";
      e(".accent-background").css("height", t);
    }),
    (theme.peekCarousel = {
      init: function t(i, o, n, a, s, r) {
        theme.peekCarousel._checkAdvice(i);
        var c = {
          $slideshows: o,
          useCarouselCheckFn: a,
          removeClasses: s,
          slickConfig:
            "object" == _typeof(r)
              ? r
              : {
                  infinite: !1,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  swipeToSlide: !0,
                  dots: !1,
                  arrows: !1,
                },
        };
        theme.peekCarousel._assess.bind(c)(),
          e(window).on(
            "debouncedresize" + n,
            theme.peekCarousel._assess.bind(c)
          ),
          e(".product-carousel-peek__advice", i).on("click", function () {
            e(this)
              .closest(".product-carousel-peek")
              .find(".slick-initialized")
              .slick("slickNext")
              .trigger("dismissAdvice");
          });
      },
      destroy: function t(i, o, n) {
        o.hasClass("slick-initialized") &&
          o.slick("unslick").off("swipe dismissAdvice afterChange init"),
          e(window).off("debouncedresize" + n, theme.peekCarousel._assess),
          e(".product-carousel-peek__advice", i).off("click");
      },
      _assess: function t() {
        for (var i = 0; i < this.$slideshows.length; i++) {
          var o = e(this.$slideshows[i]);
          this.useCarouselCheckFn()
            ? o.hasClass("slick-initialized") ||
              (this.removeClasses &&
                o.children().each(function () {
                  e(this).data("peekOriginalClassName", this.className),
                    (this.className = "");
                }),
              0 == o.children().length &&
                o
                  .closest(".product-carousel-peek")
                  .addClass("product-carousel-peek--empty"),
              1 == o.children().length &&
                o
                  .closest(".product-carousel-peek")
                  .addClass("product-carousel-peek--single"),
              o.on("afterChange init", theme.peekCarousel._lazyLoadProduct),
              o
                .slick(this.slickConfig)
                .on(
                  "swipe dismissAdvice",
                  theme.peekCarousel._dismissAdviceOnSlickSwipe
                ))
            : o.hasClass("slick-initialized") &&
              (o.slick("unslick").off("swipe dismissAdvice afterChange"),
              this.removeClasses &&
                o.children().each(function () {
                  this.className = e(this).data("peekOriginalClassName");
                }));
        }
      },
      _checkAdvice: function t(i) {
        "1" != e.cookie("theme.boost.dismissPeekAdvice") &&
          e(".product-carousel-peek", i).addClass(
            "product-carousel-peek--show-advice"
          );
      },
      _dismissAdvice: function t() {
        e.cookie("theme.boost.dismissPeekAdvice", "1", {
          expires: 7,
          path: "/",
          domain: window.location.hostname,
        }),
          e(".product-carousel-peek").addClass(
            "product-carousel-peek--dismiss-advice"
          );
      },
      _dismissAdviceOnSlickSwipe: function t(i, o) {
        theme.peekCarousel._dismissAdvice(), e(this).off("swipe");
      },
      _lazyLoadProduct: function t(i, o) {
        o.$slides
          .filter("[data-lazy-product-url]")
          .filter(function () {
            return (
              e(this).hasClass("slick-active") ||
              e(this).prev().hasClass("slick-active")
            );
          })
          .each(function () {
            var t = e(this);
            e.get(
              e(this).data("lazy-product-url") + "?view=_block",
              function (i) {
                if (
                  (t.html(
                    e("<div>" + i + "</div>")
                      .children()
                      .html()
                  ),
                  theme.settings.uniformProductGridImagesEnabled)
                ) {
                  var o = t.closest(".uhm-active");
                  o.length && o.data("uhm-callback")();
                }
              }
            ),
              t.removeAttr("data-lazy-product-url");
          });
      },
    }),
    (theme.productGallerySlideshowTabFix = function (t, i) {
      e(t[i])
        .attr("tabindex", "-1")
        .find("[tabindex]")
        .each(function () {
          e(this).attr("tabindex", "0"),
            e(this).filter("model-viewer").attr("tabindex", "-1");
        }),
        e(t)
          .not(t[i])
          .attr("tabindex", "-1")
          .find(
            "a, input, select, textarea, button, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            e(this).attr("tabindex", "-1");
          });
    }),
    e(function () {
      function t() {
        e(".tabs:not(:has(.tab--active)) a:first").trigger("assess");
      }
      slate.a11y.pageLinkFocus(e(window.location.hash)),
        e(".in-page-link").on("click", function (t) {
          slate.a11y.pageLinkFocus(e(t.currentTarget.hash));
        }),
        e(document).on("keyup.themeTabCheck", function (t) {
          9 === t.keyCode &&
            (e("body").addClass("tab-used"),
            e(document).off("keyup.themeTabCheck"));
        }),
        slate.rte.wrapTable({
          $tables: e(".rte table"),
          tableWrapperClass: "rte__table-wrapper",
        }),
        slate.rte.wrapIframe({
          $iframes: e(
            '.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'
          ),
          iframeWrapperClass: "rte__video-wrapper",
        }),
        slate.cart.cookiesEnabled() &&
          (document.documentElement.className =
            document.documentElement.className.replace(
              "supports-no-cookies",
              "supports-cookies"
            )),
        e(document).on(
          "change focusout inputstateEmpty",
          ".input-wrapper input, .input-wrapper textarea",
          function () {
            e(this)
              .closest(".input-wrapper")
              .toggleClass("is-empty", 0 == e(this).val().length);
          }
        ),
        e(document).on(
          "focusin focusout",
          ".input-wrapper input, .input-wrapper textarea",
          function (t) {
            e(this)
              .closest(".input-wrapper")
              .toggleClass("in-focus", "focusin" == t.type);
          }
        ),
        e(document).on("shopify:section:load", function () {
          e(".input-wrapper input, .input-wrapper textarea").trigger(
            "inputstateEmpty"
          );
        }),
        e(".input-wrapper input:focus, .input-wrapper textarea:focus")
          .closest(".input-wrapper")
          .addClass("in-focus"),
        e(".input-wrapper input, .input-wrapper textarea").trigger(
          "inputstateEmpty"
        ),
        e(".input-wrapper input, .input-wrapper textarea").on(
          "animationstart",
          function (t) {
            "onAutoFillStart" == t.originalEvent.animationName
              ? e(this).closest(".input-wrapper").removeClass("is-empty")
              : "onAutoFillCancel" == t.originalEvent.animationName &&
                e(this).trigger("inputstateEmpty");
          }
        ),
        e(window).width() > 1024 && e("input[data-desktop-autofocus]").focus(),
        e(document).on("click assess", ".tabs a", function (t) {
          e(this)
            .addClass("tab--active")
            .closest("ul")
            .find(".tab--active")
            .not(this)
            .removeClass("tab--active"),
            e(this)
              .closest("li")
              .siblings()
              .find("a")
              .each(function () {
                e(e(this).attr("href")).removeClass("tab-content--active");
              }),
            e(e(this).attr("href")).addClass("tab-content--active"),
            t.preventDefault();
        }),
        t(),
        e(document).on("shopify:section:load", t),
        e(document).on(
          "click",
          ".js-contains-quickbuy .js-quickbuy-button",
          function (t) {
            if (e(window).width() > 768) {
              var i = e(this),
                o = e(this).closest(".js-contains-quickbuy"),
                n = e(
                  '<div class="quickbuy">' +
                    o.find(".quickbuy-placeholder-template").html() +
                    "</div>"
                ),
                a = !1,
                s = new MutationObserver(function (t) {
                  e.colorbox.resize();
                });
              return (
                e.colorbox({
                  closeButton: !1,
                  preloading: !1,
                  open: !0,
                  speed: 200,
                  slideshow: !0,
                  html: [n.wrap("<div>").parent().html()].join(""),
                  onComplete: function t() {
                    var n = e(".quickbuy__product-media").slick({
                      infinite: !1,
                      slidesToScroll: 1,
                      speed: 300,
                      slidesToShow: 1,
                      swipeToSlide: !0,
                      variableWidth: !0,
                      prevArrow: e(".quickbuy__slider-controls .prev"),
                      nextArrow: e(".quickbuy__slider-controls .next"),
                    });
                    theme.ProductMedia.init(e(".quickbuy__media-container"), {
                      onPlyrInit: function e(t) {
                        theme.productGallerySlideshowTabFix(
                          n.slick("getSlick").$slides,
                          n.slick("getSlick").currentSlide
                        );
                      },
                      onYoutubeInit: function e(t) {
                        theme.productGallerySlideshowTabFix(
                          n.slick("getSlick").$slides,
                          n.slick("getSlick").currentSlide
                        );
                      },
                      onModelViewerInit: function e(t) {
                        theme.productGallerySlideshowTabFix(
                          n.slick("getSlick").$slides,
                          n.slick("getSlick").currentSlide
                        );
                      },
                      onVideoVisible: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !1);
                      },
                      onVideoHidden: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !0);
                      },
                      onPlyrPlay: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !1);
                      },
                      onPlyrPause: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !0);
                      },
                      onModelViewerPlay: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !1)
                          .slick("slickSetOption", "accessibility", !1)
                          .closest(".quickbuy__media-container")
                          .addClass("media-playing");
                      },
                      onModelViewerPause: function t(i) {
                        e(i.target)
                          .closest(".slick-slider")
                          .slick("slickSetOption", "swipe", !0)
                          .slick("slickSetOption", "accessibility", !0)
                          .closest(".quickbuy__media-container")
                          .removeClass("media-playing");
                      },
                    }),
                      n.find(".product-media").trigger("mediaVisibleInitial"),
                      n.on("afterChange", function (t, i, o) {
                        e(".product-media--activated")
                          .removeClass("product-media--activated")
                          .trigger("mediaHidden");
                        var a = e(".product-media", i.$slides[o])
                          .addClass("product-media--activated")
                          .trigger("mediaVisible");
                        theme.productGallerySlideshowTabFix(i.$slides, o),
                          n
                            .closest(".quickbuy__media-container")
                            .toggleClass(
                              "quickbuy__media-container--current-image",
                              a.hasClass("product-media--image")
                            ),
                          e(this)
                            .closest(".quickbuy-container")
                            .trigger("changedsize");
                      }),
                      theme.productGallerySlideshowTabFix(
                        n.slick("getSlick").$slides,
                        n.slick("getSlick").currentSlide
                      ),
                      e.colorbox.resize();
                    var r = e(".quickbuy-form"),
                      c = JSON.parse(e("[data-product-json]", o).html()),
                      l = {
                        $container: r,
                        enableHistoryState: !1,
                        singleOptionSelector: "[data-single-option-selector]",
                        originalSelectorId: "[data-product-select]",
                        product: c,
                        productSingleObject: c,
                      };
                    new slate.Variants(l),
                      r.on(
                        "variantChange",
                        theme.variants.updateAddToCartState.bind(l)
                      ),
                      r.on(
                        "variantPriceChange",
                        theme.variants.updateProductPrices.bind(l)
                      ),
                      e(".quickbuy__product-media .slick-slide", r).length >
                        1 &&
                        r.on("variantImageChange", function (t) {
                          var i = e(
                            '.quickbuy__product-media .slick-slide:not(.slick-cloned)[data-media-id="' +
                              t.variant.featured_media.id +
                              '"]',
                            r
                          );
                          i.length &&
                            i
                              .closest(".slick-slider")
                              .slick("slickGoTo", i.data("slick-index"));
                        }),
                      r.on("variantChange", e.colorbox.resize),
                      theme.styleVariantSelectors(
                        e(".quickbuy .selector-wrapper select"),
                        l.product,
                        !0
                      ),
                      theme.select2.init(e(".quickbuy .quantity-proxy"), {
                        dropdownParent: e("#cboxWrapper"),
                      }),
                      Shopify.PaymentButton &&
                        (e(document).on(
                          "shopify:payment_button:loaded.themeQuickBuy",
                          function () {
                            e(document).off(
                              "shopify:payment_button:loaded.themeQuickBuy"
                            ),
                              e.colorbox.resize(),
                              (a = e(
                                ".quickbuy-form .shopify-payment-button"
                              )[0]) &&
                                s.observe(a, {
                                  attributes: !0,
                                  childList: !0,
                                  subtree: !0,
                                });
                          }
                        ),
                        Shopify.PaymentButton.init()),
                      theme.initAjaxAddToCartForm(
                        e("form.ajax-product-form", r)
                      );
                    for (
                      var d = {
                          handle: c.handle,
                          url: i.attr("href").split("?")[0],
                          title: c.title,
                          vendor: c.vendor,
                          available: c.available,
                          image:
                            c.media.length > 0
                              ? c.media[0].preview_image.src
                              : null,
                          image2:
                            c.media.length > 1
                              ? c.media[1].preview_image.src
                              : null,
                          price: c.price,
                          priceVaries: c.price_varies,
                          compareAtPrice: c.compare_at_price,
                        },
                        h = c.variants[0],
                        u = 1;
                      u < c.variants.length;
                      u++
                    )
                      c.variants[u].price < h.price && (h = c.variants[u]);
                    h.unit_price_measurement &&
                      ((d.unitPrice = h.unit_price),
                      (d.unitPriceUnit = theme.variants.getBaseUnit(h))),
                      theme.addToAndReturnRecentProducts(d);
                  },
                  onCleanup: function t() {
                    s.disconnect(),
                      theme.ProductMedia.destroy(
                        e(".quickbuy__media-container")
                      ),
                      e(".quickbuy .slick-initialized")
                        .slick("unslick")
                        .off("afterChange"),
                      e(".quickbuy-form").off(
                        "variantChange variantPriceChange variantImageChange"
                      ),
                      e(".quickbuy-form .clickybox-replaced").clickyBoxes(
                        "destroy"
                      ),
                      theme.initAjaxAddToCartForm(
                        e(".quickbuy form.ajax-product-form")
                      );
                  },
                }),
                !1
              );
            }
          }
        ),
        e(document).on(
          "click",
          "#colorbox .quickbuy__close .js-close-quickbuy",
          function () {
            return e.colorbox.close(), !1;
          }
        ),
        e(document).on("click", ".js-close-lightbox", function () {
          return e.colorbox.close(), !1;
        }),
        e(document).on("change", ".quantity-proxy", function () {
          var t = e(this).val(),
            i = e(this).siblings('[name="quantity"]');
          "10+" == t
            ? (i.val("10").closest(".quantity-wrapper").addClass("hide-proxy"),
              setTimeout(function () {
                i.select().focus();
              }, 10))
            : i.val(t);
        });
      var i = e(".subscribe-form__response--success");
      i.length &&
        e.colorbox({
          transition: "fade",
          html:
            '<div class="subscribe-form-lightbox-response">' +
            i.html() +
            "</div>",
          onOpen: function t() {
            e("#colorbox").css("opacity", 0);
          },
          onComplete: function t() {
            e("#colorbox").animate({ opacity: 1 }, 350);
          },
        }),
        e(".accent-background").length &&
          (e(function () {
            theme.resizeAccent();
          }),
          e(window).on("debouncedresize", theme.resizeAccent),
          e(document).on("shopify:section:load", function (t) {
            e(t.target).prev().hasClass("accent-background") &&
              theme.resizeAccent();
          }),
          e(document).on("shopify:section:reorder", theme.resizeAccent));
    }),
    theme.Sections.init(),
    theme.Sections.register("header", theme.Header, { deferredLoad: !1 }),
    theme.Sections.register("footer", theme.Footer),
    theme.Sections.register("product", theme.Product, { deferredLoad: !1 }),
    theme.Sections.register("blog", theme.Blog),
    theme.Sections.register("article", theme.Article),
    theme.Sections.register("slideshow", theme.Slideshow),
    theme.Sections.register("banner", theme.Banner),
    theme.Sections.register("standout-collection", theme.StandoutCollection),
    theme.Sections.register("get-the-look", theme.GetTheLook),
    theme.Sections.register("promotional-images", theme.PromotionalImages),
    theme.Sections.register("featured-collection", theme.FeaturedCollection),
    theme.Sections.register("list-collections", theme.ListCollections, {
      deferredLoad: !1,
    }),
    theme.Sections.register("collection-template", theme.CollectionTemplate, {
      deferredLoad: !1,
    }),
    theme.Sections.register("cart", theme.Cart, { deferredLoad: !1 }),
    theme.Sections.register("image-with-text", theme.ImageWithText),
    theme.Sections.register("featured-product", theme.FeaturedProduct),
    theme.Sections.register("recently-viewed", theme.RecentlyViewed),
    theme.Sections.register("testimonials", theme.Testimonials),
    theme.Sections.register("gallery", theme.Gallery),
    theme.Sections.register("video", theme.VideoManager),
    theme.Sections.register("background-video", theme.VideoManager),
    theme.Sections.register("search-template", theme.SearchTemplate, {
      deferredLoad: !1,
    }),
    e(function (e) {
      r.sections.length
        ? r.sections.forEach(function (e) {
            try {
              theme.Sections.register(e.name, e.section);
            } catch (t) {
              console.error(
                "Unable to register section ".concat(e.name, "."),
                t
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
})(theme.jQuery);
